import { defineTranslations, type TranslationRecord } from "@festina-life/core"

import type { enConfiguredEnums, enEnums } from "./enum.en"

const onlyInDanishLayerForNow = ""

export const nlEnums = defineTranslations<TranslationRecord<typeof enEnums>>()({
  "collCalc.enum.AccountType.none": "Geen",
  "collCalc.enum.AccountType.rounding": "",
  "collCalc.enum.BatchStatusType.completed": "",
  "collCalc.enum.BatchStatusType.created": "",
  "collCalc.enum.BatchStatusType.failed": "",
  "collCalc.enum.BatchStatusType.started": "",
  "collCalc.enum.BatchStatusType.stopped": "",
  "collCalc.enum.BulkDataType.Accounts": "",
  "collCalc.enum.BulkDataType.BalancePostings": "",
  "collCalc.enum.BulkDataType.Enums": "",
  "collCalc.enum.BulkDataType.OpenPostPostings": "",
  "collCalc.enum.BulkDataType.ParameterValueIntervals": "",
  "collCalc.enum.BulkDataType.ParameterValues": "",
  "collCalc.enum.BulkDataType.TariffTemplates": "",
  "collCalc.enum.BulkDataType.Tenants": "",
  "collCalc.enum.BulkDataType.WorkPads": "",
  "collCalc.enum.BusinessType.company": "",
  "collCalc.enum.BusinessType.person": "",
  "collCalc.enum.CcCalcType.monthly": "Maandelijks",
  "collCalc.enum.CcCalcType.yearly": "Jaarlijks",
  "collCalc.enum.CcGroupType.ageMonths": "",
  "collCalc.enum.CcGroupType.ageYears": "",
  "collCalc.enum.CcInputType.x": "",
  "collCalc.enum.CcStateStatus.calculated": "Berekend",
  "collCalc.enum.CcStateStatus.failed": "Mislukt",
  "collCalc.enum.CcStateStatus.invalid": "Ongeldig",
  "collCalc.enum.CcStateStatus.succeeded": "Geslaagd",
  "collCalc.enum.CcStateStatus.superseded": "Vervangen",
  "collCalc.enum.CcStateStatus.waiting": "Afwachten",
  "collCalc.enum.CommandGroupType.advance": "",
  "collCalc.enum.CommandGroupType.annotation": "",
  "collCalc.enum.CommandGroupType.calculation": "",
  "collCalc.enum.CommandGroupType.employerAgreement": "",
  "collCalc.enum.CommandGroupType.employment": "",
  "collCalc.enum.CommandGroupType.legalEntity": "",
  "collCalc.enum.CommandGroupType.moneyIn": "",
  "collCalc.enum.CommandGroupType.moneyOut": "",
  "collCalc.enum.CommandGroupType.none": "",
  "collCalc.enum.CommandGroupType.policyChange": "",
  "collCalc.enum.CommandGroupType.posting": "",
  "collCalc.enum.CommandGroupType.tax": "",
  "collCalc.enum.CommandGroupType.unitlink": "",
  "collCalc.enum.CommandType.addAccessGroupAnnotation": "",
  "collCalc.enum.CommandType.amendAccessGroupAnnotation": "",
  "collCalc.enum.CommandType.defaultTemplate": "",
  "collCalc.enum.CommandType.removeAccessGroupAnnotation": "",
  "collCalc.enum.ConfigurationEntityType.EnumDefinition": "",
  "collCalc.enum.ConfigurationEntityType.EnumLiteral": "",
  "collCalc.enum.ConfigurationEntityType.GlMap": "",
  "collCalc.enum.ConfigurationEntityType.ParameterDefinition": "",
  "collCalc.enum.ConfigurationEntityType.ParameterValue": "",
  "collCalc.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "collCalc.enum.ConfigurationEntityType.RegisteredTenant": "",
  "collCalc.enum.ConfigurationEntityType.Template": "",
  "collCalc.enum.DataSubscriptionRoleType.unspecified": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.deleted": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.processed": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.registered": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.rejected": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.sent": "",
  "collCalc.enum.ExternalPayloadProcessStatusType.unsent": "",
  "collCalc.enum.ExternalPayloadReceiver.collcalc": "",
  "collCalc.enum.ExternalPayloadReceiver.datamart2": "",
  "collCalc.enum.ExternalPayloadReceiver.external": "",
  "collCalc.enum.ExternalPayloadReceiver.legalentity": "",
  "collCalc.enum.ExternalPayloadReceiver.life": "",
  "collCalc.enum.ExternalPayloadReceiver.moneyin": "",
  "collCalc.enum.ExternalPayloadReceiver.moneyout": "",
  "collCalc.enum.ExternalPayloadReceiver.unitlink": "",
  "collCalc.enum.ExternalPayloadType.bulkDataExport": "",
  "collCalc.enum.ExternalPayloadType.camt53": "camt.053",
  "collCalc.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "collCalc.enum.ExternalPayloadType.camt54": "camt.054",
  "collCalc.enum.ExternalPayloadType.generalLedger": "",
  "collCalc.enum.ExternalPayloadType.migration": "",
  "collCalc.enum.ExternalPayloadType.namingResponse": "",
  "collCalc.enum.ExternalPayloadType.none": "Geen",
  "collCalc.enum.ExternalPayloadType.pain001": "pain.001",
  "collCalc.enum.ExternalPayloadType.pain002": "pain.002",
  "collCalc.enum.ExternalPayloadType.testTransactionalIn": "",
  "collCalc.enum.ExternalPayloadType.testTransactionalOut": "",
  "collCalc.enum.ExternalPayloadType.testin": "",
  "collCalc.enum.ExternalPayloadType.testout": "",
  "collCalc.enum.FPlusCompletionItemTag.deprecated": "",
  "collCalc.enum.Gender.Female": "",
  "collCalc.enum.Gender.Male": "",
  "collCalc.enum.Gender.Unknown": "",
  "collCalc.enum.GlAggregationType.correction": "",
  "collCalc.enum.GlAggregationType.counter": "",
  "collCalc.enum.GlAggregationType.manual": "",
  "collCalc.enum.GlAggregationType.normal": "",
  "collCalc.enum.LogLevel.all": "",
  "collCalc.enum.LogLevel.debug": "",
  "collCalc.enum.LogLevel.error": "",
  "collCalc.enum.LogLevel.info": "",
  "collCalc.enum.LogLevel.off": "",
  "collCalc.enum.LogLevel.trace": "",
  "collCalc.enum.LogLevel.warn": "",
  "collCalc.enum.MetaAssociationOutput.aggregation": "",
  "collCalc.enum.MetaAssociationOutput.composition": "",
  "collCalc.enum.MetaCardinalityOutput.many": "",
  "collCalc.enum.MetaCardinalityOutput.one": "",
  "collCalc.enum.PostingTable.BP": "",
  "collCalc.enum.PostingTable.OPP": "",
  "collCalc.enum.PostingType.glRounding": "",
  "collCalc.enum.PostingType.glRoundingExcluded": "",
  "collCalc.enum.PostingType.none": "Geen",
  "collCalc.enum.ReportType.none": "Geen",
  "collCalc.enum.ReportingEventType.cancelled": "",
  "collCalc.enum.ReportingEventType.newReport": "",
  "collCalc.enum.ReportingEventType.reported": "",
  "collCalc.enum.ReportingEventType.update": "",
  "collCalc.enum.Step.x": "",
  "collCalc.enum.StepValueType.number": "",
  "collCalc.enum.StepValueType.percent": "",
  "collCalc.enum.TenantSubGroup.none": "Geen",
  "collCalc.enum.TestBatchSpecificationType.faulty": "",
  "collCalc.enum.TestBatchSpecificationType.noop": "",
  "collCalc.enum.TestBatchSpecificationType.normal": "",
  "dataMart.enum.AccountType.none": "",
  "dataMart.enum.BatchStatusType.completed": "",
  "dataMart.enum.BatchStatusType.created": "",
  "dataMart.enum.BatchStatusType.failed": "",
  "dataMart.enum.BatchStatusType.started": "",
  "dataMart.enum.BatchStatusType.stopped": "",
  "dataMart.enum.ConfigurationEntityType.EnumDefinition": "",
  "dataMart.enum.ConfigurationEntityType.EnumLiteral": "",
  "dataMart.enum.ConfigurationEntityType.GlMap": "",
  "dataMart.enum.ConfigurationEntityType.ParameterDefinition": "",
  "dataMart.enum.ConfigurationEntityType.ParameterValue": "",
  "dataMart.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "dataMart.enum.ConfigurationEntityType.RegisteredTenant": "",
  "dataMart.enum.ConfigurationEntityType.Template": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.deleted": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.processed": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.registered": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.rejected": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.sent": "",
  "dataMart.enum.ExternalPayloadProcessStatusType.unsent": "",
  "dataMart.enum.ExternalPayloadReceiver.external": "",
  "dataMart.enum.ExternalPayloadType.generalLedger": "",
  "dataMart.enum.ExternalPayloadType.none": "",
  "dataMart.enum.ExternalPayloadType.testTransactionalIn": "",
  "dataMart.enum.ExternalPayloadType.testTransactionalOut": "",
  "dataMart.enum.ExternalPayloadType.testin": "",
  "dataMart.enum.ExternalPayloadType.testout": "",
  "dataMart.enum.FPlusCompletionItemTag.deprecated": "",
  "dataMart.enum.GlAggregationType.correction": "",
  "dataMart.enum.GlAggregationType.counter": "",
  "dataMart.enum.GlAggregationType.manual": "",
  "dataMart.enum.GlAggregationType.normal": "",
  "dataMart.enum.LogLevel.all": "",
  "dataMart.enum.LogLevel.debug": "",
  "dataMart.enum.LogLevel.error": "",
  "dataMart.enum.LogLevel.info": "",
  "dataMart.enum.LogLevel.off": "",
  "dataMart.enum.LogLevel.trace": "",
  "dataMart.enum.LogLevel.warn": "",
  "dataMart.enum.MetaAssociationOutput.aggregation": "",
  "dataMart.enum.MetaAssociationOutput.composition": "",
  "dataMart.enum.MetaCardinalityOutput.many": "",
  "dataMart.enum.MetaCardinalityOutput.one": "",
  "dataMart.enum.PostingTable.BP": "",
  "dataMart.enum.PostingTable.OPP": "",
  "dataMart.enum.PostingType.none": "",
  "dataMart.enum.TestBatchSpecificationType.faulty": "",
  "dataMart.enum.TestBatchSpecificationType.noop": "",
  "dataMart.enum.TestBatchSpecificationType.normal": "",
  "dataMart2.enum.AccountType.none": "",
  "dataMart2.enum.AccountType.rounding": "",
  "dataMart2.enum.BatchStatusType.completed": "",
  "dataMart2.enum.BatchStatusType.created": "",
  "dataMart2.enum.BatchStatusType.failed": "",
  "dataMart2.enum.BatchStatusType.started": "",
  "dataMart2.enum.BatchStatusType.stopped": "",
  "dataMart2.enum.BulkDataType.Accounts": "",
  "dataMart2.enum.BulkDataType.BalancePostings": "",
  "dataMart2.enum.BulkDataType.Enums": "",
  "dataMart2.enum.BulkDataType.OpenPostPostings": "",
  "dataMart2.enum.BulkDataType.ParameterValueIntervals": "",
  "dataMart2.enum.BulkDataType.ParameterValues": "",
  "dataMart2.enum.BulkDataType.TariffTemplates": "",
  "dataMart2.enum.BulkDataType.Tenants": "",
  "dataMart2.enum.BulkDataType.WorkPads": "",
  "dataMart2.enum.BusinessType.company": "",
  "dataMart2.enum.BusinessType.person": "",
  "dataMart2.enum.CommandGroupType.advance": "",
  "dataMart2.enum.CommandGroupType.annotation": "",
  "dataMart2.enum.CommandGroupType.calculation": "",
  "dataMart2.enum.CommandGroupType.employerAgreement": "",
  "dataMart2.enum.CommandGroupType.employment": "",
  "dataMart2.enum.CommandGroupType.legalEntity": "",
  "dataMart2.enum.CommandGroupType.moneyIn": "",
  "dataMart2.enum.CommandGroupType.moneyOut": "",
  "dataMart2.enum.CommandGroupType.none": "",
  "dataMart2.enum.CommandGroupType.policyChange": "",
  "dataMart2.enum.CommandGroupType.posting": "",
  "dataMart2.enum.CommandGroupType.tax": "",
  "dataMart2.enum.CommandGroupType.unitlink": "",
  "dataMart2.enum.CommandType.addAccessGroupAnnotation": "",
  "dataMart2.enum.CommandType.amendAccessGroupAnnotation": "",
  "dataMart2.enum.CommandType.defaultTemplate": "",
  "dataMart2.enum.CommandType.removeAccessGroupAnnotation": "",
  "dataMart2.enum.ConfigurationEntityType.EnumDefinition": "",
  "dataMart2.enum.ConfigurationEntityType.EnumLiteral": "",
  "dataMart2.enum.ConfigurationEntityType.GlMap": "",
  "dataMart2.enum.ConfigurationEntityType.ParameterDefinition": "",
  "dataMart2.enum.ConfigurationEntityType.ParameterValue": "",
  "dataMart2.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "dataMart2.enum.ConfigurationEntityType.RegisteredTenant": "",
  "dataMart2.enum.ConfigurationEntityType.Template": "",
  "dataMart2.enum.DataSubscriptionRoleType.unspecified": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.deleted": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.processed": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.registered": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.rejected": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.sent": "",
  "dataMart2.enum.ExternalPayloadProcessStatusType.unsent": "",
  "dataMart2.enum.ExternalPayloadReceiver.collcalc": "",
  "dataMart2.enum.ExternalPayloadReceiver.datamart2": "",
  "dataMart2.enum.ExternalPayloadReceiver.external": "",
  "dataMart2.enum.ExternalPayloadReceiver.legalentity": "",
  "dataMart2.enum.ExternalPayloadReceiver.life": "",
  "dataMart2.enum.ExternalPayloadReceiver.moneyin": "",
  "dataMart2.enum.ExternalPayloadReceiver.moneyout": "",
  "dataMart2.enum.ExternalPayloadReceiver.unitlink": "",
  "dataMart2.enum.ExternalPayloadType.bulkDataExport": "",
  "dataMart2.enum.ExternalPayloadType.camt53": "",
  "dataMart2.enum.ExternalPayloadType.camt53Returns": "",
  "dataMart2.enum.ExternalPayloadType.camt54": "",
  "dataMart2.enum.ExternalPayloadType.generalLedger": "",
  "dataMart2.enum.ExternalPayloadType.migration": "",
  "dataMart2.enum.ExternalPayloadType.namingResponse": "",
  "dataMart2.enum.ExternalPayloadType.none": "",
  "dataMart2.enum.ExternalPayloadType.pain001": "",
  "dataMart2.enum.ExternalPayloadType.pain002": "",
  "dataMart2.enum.ExternalPayloadType.testTransactionalIn": "",
  "dataMart2.enum.ExternalPayloadType.testTransactionalOut": "",
  "dataMart2.enum.ExternalPayloadType.testin": "",
  "dataMart2.enum.ExternalPayloadType.testout": "",
  "dataMart2.enum.FPlusCompletionItemTag.deprecated": "",
  "dataMart2.enum.Gender.Female": "",
  "dataMart2.enum.Gender.Male": "",
  "dataMart2.enum.Gender.Unknown": "",
  "dataMart2.enum.GlAggregationType.correction": "",
  "dataMart2.enum.GlAggregationType.counter": "",
  "dataMart2.enum.GlAggregationType.manual": "",
  "dataMart2.enum.GlAggregationType.normal": "",
  "dataMart2.enum.LogLevel.all": "",
  "dataMart2.enum.LogLevel.debug": "",
  "dataMart2.enum.LogLevel.error": "",
  "dataMart2.enum.LogLevel.info": "",
  "dataMart2.enum.LogLevel.off": "",
  "dataMart2.enum.LogLevel.trace": "",
  "dataMart2.enum.LogLevel.warn": "",
  "dataMart2.enum.MetaAssociationOutput.aggregation": "",
  "dataMart2.enum.MetaAssociationOutput.composition": "",
  "dataMart2.enum.MetaCardinalityOutput.many": "",
  "dataMart2.enum.MetaCardinalityOutput.one": "",
  "dataMart2.enum.PostingTable.BP": "",
  "dataMart2.enum.PostingTable.OPP": "",
  "dataMart2.enum.PostingType.glRounding": "",
  "dataMart2.enum.PostingType.glRoundingExcluded": "",
  "dataMart2.enum.PostingType.none": "",
  "dataMart2.enum.ReconciliationResultStatus.ACCEPTED": "",
  "dataMart2.enum.ReconciliationResultStatus.MATCH": "",
  "dataMart2.enum.ReconciliationResultStatus.MISMATCH": "",
  "dataMart2.enum.ReconciliationResultStatus.PENDING": "",
  "dataMart2.enum.ReportType.none": "",
  "dataMart2.enum.ReportingEventType.cancelled": "",
  "dataMart2.enum.ReportingEventType.newReport": "",
  "dataMart2.enum.ReportingEventType.reported": "",
  "dataMart2.enum.ReportingEventType.update": "",
  "dataMart2.enum.TestBatchSpecificationType.faulty": "",
  "dataMart2.enum.TestBatchSpecificationType.noop": "",
  "dataMart2.enum.TestBatchSpecificationType.normal": "",
  "legalEntity.enum.AccountType.none": "Geen",
  "legalEntity.enum.AccountType.rounding": "",
  "legalEntity.enum.AddressType.formal": "Formeel",
  "legalEntity.enum.AddressType.informal": "Informeel",
  "legalEntity.enum.AddressTypeMigrationV1Data.formal": "Formeel",
  "legalEntity.enum.AddressTypeMigrationV1Data.informal": "Informeel",
  "legalEntity.enum.BatchStatusType.completed": "Voltooid",
  "legalEntity.enum.BatchStatusType.created": "Aangemaakt",
  "legalEntity.enum.BatchStatusType.failed": "Mislukt",
  "legalEntity.enum.BatchStatusType.started": "Gestart",
  "legalEntity.enum.BatchStatusType.stopped": "Gestopt",
  "legalEntity.enum.BulkDataType.Accounts": "",
  "legalEntity.enum.BulkDataType.BalancePostings": "",
  "legalEntity.enum.BulkDataType.Enums": "",
  "legalEntity.enum.BulkDataType.OpenPostPostings": "",
  "legalEntity.enum.BulkDataType.ParameterValueIntervals": "",
  "legalEntity.enum.BulkDataType.ParameterValues": "",
  "legalEntity.enum.BulkDataType.TariffTemplates": "",
  "legalEntity.enum.BulkDataType.Tenants": "",
  "legalEntity.enum.BulkDataType.WorkPads": "",
  "legalEntity.enum.BusinessType.company": "",
  "legalEntity.enum.BusinessType.person": "",
  "legalEntity.enum.CommandGroupType.advance": "Doorgaan",
  "legalEntity.enum.CommandGroupType.annotation": "Annotatie",
  "legalEntity.enum.CommandGroupType.calculation": "Berekening",
  "legalEntity.enum.CommandGroupType.employerAgreement": "Werkgeversovereenkomst",
  "legalEntity.enum.CommandGroupType.employment": "Dienstverband",
  "legalEntity.enum.CommandGroupType.legalEntity": "Rechtspersoon",
  "legalEntity.enum.CommandGroupType.moneyIn": "Incasso",
  "legalEntity.enum.CommandGroupType.moneyOut": "Excasso",
  "legalEntity.enum.CommandGroupType.none": "Geen",
  "legalEntity.enum.CommandGroupType.policyChange": "Wijzig polis",
  "legalEntity.enum.CommandGroupType.posting": "Boekingen",
  "legalEntity.enum.CommandGroupType.tax": "Belasting",
  "legalEntity.enum.CommandGroupType.unitlink": "UnitLink",
  "legalEntity.enum.CommandType.addAccessGroupAnnotation": "Toevoegen annotatie",
  "legalEntity.enum.CommandType.addEmployeeName": "Toevoegen naam werknemer",
  "legalEntity.enum.CommandType.addressChange": "Wijzig adres",
  "legalEntity.enum.CommandType.amendAccessGroupAnnotation": "Wijzigen annotatie",
  "legalEntity.enum.CommandType.birthDateChange": "Wijzig geboortedatum",
  "legalEntity.enum.CommandType.changeLegalEntity": "Wijzig rechtspersoon",
  "legalEntity.enum.CommandType.companyExternalIdChange": "Wijzig externe bedrijfs-ID",
  "legalEntity.enum.CommandType.createCompany": "Aanmaken bedrijf",
  "legalEntity.enum.CommandType.createMigrationPartnerV3": "Aanmaken migratie partner V3",
  "legalEntity.enum.CommandType.createMigrationPartnerV4": "Aanmaken migratie partner V4",
  "legalEntity.enum.CommandType.createMigrationPartnersV2": "Aanmaken migratie partner v@",
  "legalEntity.enum.CommandType.createPerson": "Aanmaken persoon",
  "legalEntity.enum.CommandType.createPersonMigrationV3": "Aanmaken migratie persoon V3",
  "legalEntity.enum.CommandType.createPersonMigrationV4": "Aanmaken migratie persoon V4",
  "legalEntity.enum.CommandType.createPersonMigrationV5": "Aanmaken migratie persoon V5",
  "legalEntity.enum.CommandType.defaultTemplate": "Standaard sjabloon",
  "legalEntity.enum.CommandType.deleteAddress": "Verwijder adres",
  "legalEntity.enum.CommandType.endPartnership": "Einde relatie",
  "legalEntity.enum.CommandType.externalIdChange": "Wijzig externe ID",
  "legalEntity.enum.CommandType.genderChange": "Wijzig geslacht",
  "legalEntity.enum.CommandType.partnerBirthdateChange": "Wijzig geboortedatum partner",
  "legalEntity.enum.CommandType.partnerDeceased": "Partner overleden",
  "legalEntity.enum.CommandType.partnerIdChange": "Wijzig partner-ID",
  "legalEntity.enum.CommandType.partnerNameChange": "Wijzig naam partner",
  "legalEntity.enum.CommandType.personDeceased": "Persoon overleden",
  "legalEntity.enum.CommandType.personNameChange": "Wijzig naam persoon",
  "legalEntity.enum.CommandType.personRelocation": "Verhuizing persoon",
  "legalEntity.enum.CommandType.pointOfContactChange": "Wijzig aanspreekpunt",
  "legalEntity.enum.CommandType.removeAccessGroupAnnotation": "Verwijderen annotatie",
  "legalEntity.enum.CommandType.rollback": "Terudraaien",
  "legalEntity.enum.CommandType.setPersonState": "Wijzig status persoon",
  "legalEntity.enum.CommandType.singleAddressChange": "Wijzig één adres",
  "legalEntity.enum.CommandType.startPartnership": "Start relatie",
  "legalEntity.enum.CommandType.updateCommunicationPreference": "Update communicatie voorkeur",
  "legalEntity.enum.CommandType.updateCompany": "Bedrijf bijwerken",
  "legalEntity.enum.CommandType.updateCompanyName": "Update bedrijfsnaam",
  "legalEntity.enum.CommandType.updatePartnership": "Update relatie",
  "legalEntity.enum.CommandType.updatePerson": "Persoon bijwerken",
  "legalEntity.enum.CommunicationPreferenceType.digital": "Digitaal",
  "legalEntity.enum.CommunicationPreferenceType.post": "Post",
  "legalEntity.enum.Component.caseHandler": "",
  "legalEntity.enum.Component.legalEntity": "Rechtspersoon",
  "legalEntity.enum.Component.life": "Life",
  "legalEntity.enum.Component.moneyIn": "Incasso",
  "legalEntity.enum.Component.moneyOut": "Excasso",
  "legalEntity.enum.Component.unitlink": "UnitLink",
  "legalEntity.enum.ConfigurationEntityType.EnumDefinition": "",
  "legalEntity.enum.ConfigurationEntityType.EnumLiteral": "",
  "legalEntity.enum.ConfigurationEntityType.GlMap": "",
  "legalEntity.enum.ConfigurationEntityType.ParameterDefinition": "",
  "legalEntity.enum.ConfigurationEntityType.ParameterValue": "",
  "legalEntity.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "legalEntity.enum.ConfigurationEntityType.RegisteredTenant": "",
  "legalEntity.enum.ConfigurationEntityType.Template": "",
  "legalEntity.enum.DataSubscriptionRoleType.unspecified": "",
  "legalEntity.enum.EventStopKind.applyStop": "",
  "legalEntity.enum.EventStopKind.communicationStop": "",
  "legalEntity.enum.EventStopKind.errorApplyStop": "",
  "legalEntity.enum.EventStopKind.fullStop": "",
  "legalEntity.enum.ExternalPayloadProcessStatusType.deleted": "Verwijderd",
  "legalEntity.enum.ExternalPayloadProcessStatusType.processed": "Verwerkt",
  "legalEntity.enum.ExternalPayloadProcessStatusType.registered": "Geregistreerd",
  "legalEntity.enum.ExternalPayloadProcessStatusType.rejected": "Afgewezen",
  "legalEntity.enum.ExternalPayloadProcessStatusType.sent": "Verzonden",
  "legalEntity.enum.ExternalPayloadProcessStatusType.unsent": "Niet verzonden",
  "legalEntity.enum.ExternalPayloadReceiver.collcalc": "Collectieve berekeningen",
  "legalEntity.enum.ExternalPayloadReceiver.datamart2": "",
  "legalEntity.enum.ExternalPayloadReceiver.external": "Extern",
  "legalEntity.enum.ExternalPayloadReceiver.legalentity": "Rechtspersoon",
  "legalEntity.enum.ExternalPayloadReceiver.life": "Life",
  "legalEntity.enum.ExternalPayloadReceiver.moneyin": "Incasso",
  "legalEntity.enum.ExternalPayloadReceiver.moneyout": "Excasso",
  "legalEntity.enum.ExternalPayloadReceiver.unitlink": "UnitLink",
  "legalEntity.enum.ExternalPayloadType.bs601BillingExt": "Externe bs 0601 facturering",
  "legalEntity.enum.ExternalPayloadType.bulkDataExport": "",
  "legalEntity.enum.ExternalPayloadType.camt53": "camt.053",
  "legalEntity.enum.ExternalPayloadType.camt53Ext": "Extern camt.053",
  "legalEntity.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "legalEntity.enum.ExternalPayloadType.camt53ReturnsExt": "Extern camt.053 retour",
  "legalEntity.enum.ExternalPayloadType.camt54": "camt.054",
  "legalEntity.enum.ExternalPayloadType.camt54Ext": "Extern camt.054",
  "legalEntity.enum.ExternalPayloadType.eIndkomstExt": onlyInDanishLayerForNow,
  "legalEntity.enum.ExternalPayloadType.eIndkomstReceiptExt": onlyInDanishLayerForNow,
  "legalEntity.enum.ExternalPayloadType.generalLedger": "Grootboek",
  "legalEntity.enum.ExternalPayloadType.legalEntityRecordsFile": "Rechtspersoon records bestand",
  "legalEntity.enum.ExternalPayloadType.migration": "Migratie",
  "legalEntity.enum.ExternalPayloadType.namingResponse": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemDataRequestExt": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemDataResponseExt": "",
  "legalEntity.enum.ExternalPayloadType.namingSystemMappingRequestExt": "Externe request naamgeving systeem mapping",
  "legalEntity.enum.ExternalPayloadType.namingSystemMappingResponseExt": "Externe response naamgeving systeem mapping",
  "legalEntity.enum.ExternalPayloadType.none": "Geen",
  "legalEntity.enum.ExternalPayloadType.pain001": "pain.001",
  "legalEntity.enum.ExternalPayloadType.pain001Ext": "pain.001 ext",
  "legalEntity.enum.ExternalPayloadType.pain002": "pain.002",
  "legalEntity.enum.ExternalPayloadType.pain002Ext": "pain.002 ext",
  "legalEntity.enum.ExternalPayloadType.personRegistrySubscriptionOutExt": "Uitgaande externe rechtspersoon registratie abonnement",
  "legalEntity.enum.ExternalPayloadType.testTransactionalIn": "",
  "legalEntity.enum.ExternalPayloadType.testTransactionalOut": "",
  "legalEntity.enum.ExternalPayloadType.testin": "Test in",
  "legalEntity.enum.ExternalPayloadType.testout": "Test uit",
  "legalEntity.enum.FPlusCompletionItemTag.deprecated": "",
  "legalEntity.enum.Gender.Female": "Vrouw",
  "legalEntity.enum.Gender.Male": "Man",
  "legalEntity.enum.Gender.Unknown": "Onbekend",
  "legalEntity.enum.GenderMigrationV1Data.female": "Vrouw",
  "legalEntity.enum.GenderMigrationV1Data.male": "Man",
  "legalEntity.enum.GenderMigrationV1Data.unknown": "Onbekend",
  "legalEntity.enum.GlAggregationType.correction": "Correctie",
  "legalEntity.enum.GlAggregationType.counter": "Teller",
  "legalEntity.enum.GlAggregationType.manual": "Handmatig",
  "legalEntity.enum.GlAggregationType.normal": "Normaal",
  "legalEntity.enum.IdentityType.external": "Extern",
  "legalEntity.enum.IdentityType.internal": "Intern",
  "legalEntity.enum.InformationSource.employer": "Werkgever",
  "legalEntity.enum.InformationSource.migration": "Migratie",
  "legalEntity.enum.InformationSource.participant": "Deelnemer",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.subscribeInProgress": "Abonneren in behandeling",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.subscribed": "Geabonneerd",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.unsubscribeInProgress": "Opzeggen abonnement in behandeling",
  "legalEntity.enum.LegalEntityRegistrySubscriptionStatus.unsubscribed": "Abonnement opgezegd",
  "legalEntity.enum.LegalEntityType.company": "Bedrijf",
  "legalEntity.enum.LegalEntityType.person": "Persoon",
  "legalEntity.enum.LogLevel.all": "Alle",
  "legalEntity.enum.LogLevel.debug": "Debug",
  "legalEntity.enum.LogLevel.error": "Fouten",
  "legalEntity.enum.LogLevel.info": "Info",
  "legalEntity.enum.LogLevel.off": "Uit",
  "legalEntity.enum.LogLevel.trace": "Trace",
  "legalEntity.enum.LogLevel.warn": "Waarschuwingen",
  "legalEntity.enum.MetaAssociationOutput.aggregation": "Aggregatie",
  "legalEntity.enum.MetaAssociationOutput.composition": "Samenstelling",
  "legalEntity.enum.MetaCardinalityOutput.many": "Veel",
  "legalEntity.enum.MetaCardinalityOutput.one": "Eén",
  "legalEntity.enum.PartnershipType.cohabitant": "Samenwonend",
  "legalEntity.enum.PartnershipType.married": "Getrouwd",
  "legalEntity.enum.PartnershipType.registeredPartnership": "Geregistreerde partnerschap",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.cohabitant": "Samenwonend",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.married": "Getrouwd",
  "legalEntity.enum.PartnershipTypeMigrationV1Data.registeredPartnership": "Geregistreerde partnerschap",
  "legalEntity.enum.PiiTextType.unspecified": "",
  "legalEntity.enum.PostingTable.BP": "Balansboekingstabel",
  "legalEntity.enum.PostingTable.OPP": "Open boekingstabel",
  "legalEntity.enum.PostingType.glRounding": "Afronding grootboek",
  "legalEntity.enum.PostingType.glRoundingExcluded": "",
  "legalEntity.enum.PostingType.none": "Geen",
  "legalEntity.enum.RegistrySubscriptionLevel.fullRegistrySubscription": "Volledige registratie abonnement",
  "legalEntity.enum.RegistrySubscriptionLevel.none": "Geen",
  "legalEntity.enum.RegistrySubscriptionLevel.onDemand": "Op aanvraag",
  "legalEntity.enum.RegistrySubscriptionRoleType.unspecified": "Niet gespecificeerd",
  "legalEntity.enum.ReportType.none": "Geen",
  "legalEntity.enum.ReportType.personRegistrySubscription": "",
  "legalEntity.enum.ReportingEventType.cancelled": "",
  "legalEntity.enum.ReportingEventType.newReport": "",
  "legalEntity.enum.ReportingEventType.reported": "",
  "legalEntity.enum.ReportingEventType.update": "",
  "legalEntity.enum.TestBatchSpecificationType.faulty": "Defect",
  "legalEntity.enum.TestBatchSpecificationType.noop": "Noop",
  "legalEntity.enum.TestBatchSpecificationType.normal": "Normaal",
  "legalEntity.enum.TransitExternalPayloadStatus.failed": "Mislukt",
  "legalEntity.enum.TransitExternalPayloadStatus.modified": "Aangepast",
  "legalEntity.enum.TransitExternalPayloadStatus.received": "Ontvangen",
  "life.enum.AccountType.billing": "Facturering",
  "life.enum.AccountType.billingRequest": "Factureringsverzoek",
  "life.enum.AccountType.billingRequestCounter": "Tegenrekening factureringsverzoek",
  "life.enum.AccountType.claim": "Claim",
  "life.enum.AccountType.fromMoneyOutShadow": "Van schaduw excasso",
  "life.enum.AccountType.layerReserve": "Laagreserve",
  "life.enum.AccountType.moneyIn": "Incasso",
  "life.enum.AccountType.moneyInShadow": "Schaduw incasso",
  "life.enum.AccountType.moneyOut": "Excasso",
  "life.enum.AccountType.moneyOutShadow": "Schaduw excasso",
  "life.enum.AccountType.none": "Geen",
  "life.enum.AccountType.payloadIn": "Payload in",
  "life.enum.AccountType.payloadRejected": "Payload afgewezen",
  "life.enum.AccountType.payloadShadow": "Payload schaduw",
  "life.enum.AccountType.policyMoneyIn": "Polis incasso",
  "life.enum.AccountType.rounding": "Afronding",
  "life.enum.AccountType.savings": "Kapitaal",
  "life.enum.AccountType.sentToUnitlink": "Verzonden naar UnitLink",
  "life.enum.AccountType.toMoneyIn": "Naar incasso",
  "life.enum.AccountType.toMoneyInShadow": "Naar schaduw incasso",
  "life.enum.AccountType.toMoneyOut": "Naar excasso",
  "life.enum.AccountType.toUnitLinkOut": "Naar UnitLink uit",
  "life.enum.AccountType.toUnitLinkOutShadow": "Naar UnitLink schaduw iut",
  "life.enum.AccountType.unitLinkIn": "UnitLink in",
  "life.enum.AccountType.unitLinkInShadow": "UnitLink in schaduw",
  "life.enum.AccountType.unitLinkOut": "UnitLink uit",
  "life.enum.AccountType.unitLinkOutCounter": "UnitLink uit teller",
  "life.enum.BatchStatusType.completed": "Voltooid",
  "life.enum.BatchStatusType.created": "Aangemaakt",
  "life.enum.BatchStatusType.failed": "Mislukt",
  "life.enum.BatchStatusType.started": "Gestart",
  "life.enum.BatchStatusType.stopped": "Gestopt",
  "life.enum.BillingChannel.bS": "Facturatiekanaal",
  "life.enum.BillingFrequency.halfyear": "Halfjaarlijks",
  "life.enum.BillingFrequency.month": "Maandelijks",
  "life.enum.BillingFrequency.quarter": "Per kwartaal",
  "life.enum.BillingFrequency.year": "Jaarlijks",
  "life.enum.BulkDataType.Accounts": "",
  "life.enum.BulkDataType.BalancePostings": "",
  "life.enum.BulkDataType.Enums": "",
  "life.enum.BulkDataType.OpenPostPostings": "",
  "life.enum.BulkDataType.ParameterValueIntervals": "",
  "life.enum.BulkDataType.ParameterValues": "",
  "life.enum.BulkDataType.TariffTemplates": "",
  "life.enum.BulkDataType.Tenants": "",
  "life.enum.BulkDataType.WorkPads": "",
  "life.enum.BusinessType.company": "",
  "life.enum.BusinessType.person": "",
  "life.enum.CommandGroupType.advance": "Doorgaan",
  "life.enum.CommandGroupType.annotation": "Annotatie",
  "life.enum.CommandGroupType.calculation": "Berekening",
  "life.enum.CommandGroupType.employerAgreement": "Werkgeversovereenkomst",
  "life.enum.CommandGroupType.employment": "Dienstverband",
  "life.enum.CommandGroupType.legalEntity": "Rechtspersoon",
  "life.enum.CommandGroupType.moneyIn": "Incasso",
  "life.enum.CommandGroupType.moneyOut": "Excasso",
  "life.enum.CommandGroupType.none": "Geen",
  "life.enum.CommandGroupType.policyChange": "Wijzig polis",
  "life.enum.CommandGroupType.posting": "Boekingen",
  "life.enum.CommandGroupType.tax": "Belasting",
  "life.enum.CommandGroupType.unitlink": "UnitLink",
  "life.enum.CommandType.addAccessGroupAnnotation": "Toevoegen annotatie",
  "life.enum.CommandType.addBalancePostings": "Toevoegen saldo boekingen",
  "life.enum.CommandType.addManualPayment": "Toevoegen handmatige betaling",
  "life.enum.CommandType.amendAccessGroupAnnotation": "Wijzigen annotatie",
  "life.enum.CommandType.amendCoversSelection": "Wijzig dekkingen",
  "life.enum.CommandType.amendEmployerAgreement": "Wijzig werkgeversovereenkomst",
  "life.enum.CommandType.amendEmployerAgreementCovers": "Wijzig werkgeversovereenkomst dekkingen",
  "life.enum.CommandType.amendEmployerAgreementPolicies": "Wijzig werkgeversovereenkomst polissen",
  "life.enum.CommandType.changeAgreement": "Wijzig overeenkomst",
  "life.enum.CommandType.changeCommitmentAndState": "Wijzig toezegging en status",
  "life.enum.CommandType.changeCommitmentTemplateSource": "Wijzig bron sjabloon toezegging",
  "life.enum.CommandType.changeContributionData": "Wijzig betalingsgegevens",
  "life.enum.CommandType.changeName": "Wijzig naam",
  "life.enum.CommandType.changeTaxExemption": "Wijzig belastingvrijstelling",
  "life.enum.CommandType.changeTemplateSource": "Wijzig bron sjabloon",
  "life.enum.CommandType.createAgreement": "Aanmaken overeenkomst",
  "life.enum.CommandType.deathClaim": "Overlijdensclaim",
  "life.enum.CommandType.deathClaimOrphan": "Overlijdensclaim wees",
  "life.enum.CommandType.defaultTemplate": "Standaard sjabloon",
  "life.enum.CommandType.employerAgreementRollback": "Werkgeversovereenkomst terugdraaien",
  "life.enum.CommandType.employment": "Dienstverband",
  "life.enum.CommandType.employmentContribution": "Premiebetaling",
  "life.enum.CommandType.employmentEnd": "Einde dienstverband",
  "life.enum.CommandType.employmentPosting": "Boeking dienstverband",
  "life.enum.CommandType.employmentStart": "Start dienstverband",
  "life.enum.CommandType.employmentUpdate": "Update dienstverband",
  "life.enum.CommandType.handleMoneyIn": "Verwerken incasso",
  "life.enum.CommandType.handleMoneyInBillingPayment": "Verwerken inkomende facturatie betalingen",
  "life.enum.CommandType.handleUnitlinkBalance": "Verwerken UnitLink saldo",
  "life.enum.CommandType.handleUnitlinkClosedPortfolio": "Verwerken gesloten UnitLink portfolio",
  "life.enum.CommandType.handleUnitlinkClosedSubPortfolioReturn": "Verwerken retour gesloten UnitLink sub-portfolio",
  "life.enum.CommandType.handleUnitlinkYield": "UnitLink-rendement verwerken",
  "life.enum.CommandType.insuredPersonState": "Status verzekerde persoon",
  "life.enum.CommandType.internalCoverTransfer": "Interne overdracht dekking",
  "life.enum.CommandType.internalTransfer": "Interne overdracht",
  "life.enum.CommandType.newCommitment": "Nieuwe toezegging",
  "life.enum.CommandType.newPolicy": "Nieuwe polis",
  "life.enum.CommandType.pretendAddInsured": "Verzekerde toevoegen simulatie",
  "life.enum.CommandType.pretendDeath": "Overlijden simulatie",
  "life.enum.CommandType.prognosisHandleMoneyIn": "Verwerken prognose incasso",
  "life.enum.CommandType.prognosisHandleMoneyInBillingPayment": "Prognose verwerken inkomende facturatie betalingen",
  "life.enum.CommandType.projectionJump": "Projectiesprong",
  "life.enum.CommandType.projectionStart": "Start projectie",
  "life.enum.CommandType.relatedPersonState": "Status gerelateerde persoon",
  "life.enum.CommandType.relatedPersonStateSimulation": "Simulatie status gerelateerde persoon",
  "life.enum.CommandType.removeAccessGroupAnnotation": "Verwijderen annotatie",
  "life.enum.CommandType.retirement": "Pensionering",
  "life.enum.CommandType.rollback": "Terugdraaien",
  "life.enum.CommandType.simulateTo": "Simuleer tot",
  "life.enum.CommandType.transformCover": "Transformeer dekking",
  "life.enum.CommandType.valueTransferOut": "Uitgaande waardeoverdracht",
  "life.enum.CommitmentStatus.contribution": "Premiebetalend",
  "life.enum.CommitmentStatus.death": "Overleden",
  "life.enum.CommitmentStatus.deathRegistered": "Overlijden geregistreerd",
  "life.enum.CommitmentStatus.disabled": "Arbeidsongeschikt",
  "life.enum.CommitmentStatus.disbursement": "Uitkerend",
  "life.enum.CommitmentStatus.paidUp": "Slaper",
  "life.enum.CommitmentStatus.partialDisabled": "Gedeeltelijk arbeidsongeschikt",
  "life.enum.CommitmentStatus.partialRetired": "Deeltijd Pensioen",
  "life.enum.CommitmentStatus.premiumHoliday": "Premievakantie",
  "life.enum.CommitmentStatus.retired": "Gepensioneerd",
  "life.enum.CommitmentStatus.terminated": "Beëindigd",
  "life.enum.CommitmentStatus.unknown": "Onbekend",
  "life.enum.CommitmentStatus.voluntaryContribution": "Vrijwillig bijdrage",
  "life.enum.ConfigurationEntityType.EnumDefinition": "",
  "life.enum.ConfigurationEntityType.EnumLiteral": "",
  "life.enum.ConfigurationEntityType.GlMap": "",
  "life.enum.ConfigurationEntityType.ParameterDefinition": "",
  "life.enum.ConfigurationEntityType.ParameterValue": "",
  "life.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "life.enum.ConfigurationEntityType.RegisteredTenant": "",
  "life.enum.ConfigurationEntityType.Template": "",
  "life.enum.CoverProductType.none": "Geen",
  "life.enum.CoverStatus.contribution": "Premiebetalend",
  "life.enum.CoverStatus.disbursement": "Uitkerend",
  "life.enum.CoverStatus.paidUp": "Slaper",
  "life.enum.CoverStatus.terminated": "Beëindigd",
  "life.enum.DataSubscriptionRoleType.unspecified": "Niet gespecificeerd",
  "life.enum.EditType.create": "Aanmaken",
  "life.enum.EditType.delete": "Verwijderen",
  "life.enum.EditType.update": "Updaten",
  "life.enum.EmployerAgreementEndType.none": "Geen",
  "life.enum.EmployerAgreementStatus.active": "Actief",
  "life.enum.EmployerAgreementStatus.future": "Toekomstig",
  "life.enum.EmployerAgreementStatus.terminated": "Beëindigd",
  "life.enum.EmployerAgreementType.none": "Geen",
  "life.enum.EventStopKind.applyStop": "",
  "life.enum.EventStopKind.communicationStop": "",
  "life.enum.EventStopKind.errorApplyStop": "",
  "life.enum.EventStopKind.fullStop": "",
  "life.enum.ExternalPayloadProcessStatusType.deleted": "Verwijderd",
  "life.enum.ExternalPayloadProcessStatusType.processed": "Verwerkt",
  "life.enum.ExternalPayloadProcessStatusType.registered": "Geregistreerd",
  "life.enum.ExternalPayloadProcessStatusType.rejected": "Afgewezen",
  "life.enum.ExternalPayloadProcessStatusType.sent": "Verzonden",
  "life.enum.ExternalPayloadProcessStatusType.unsent": "Niet verzonden",
  "life.enum.ExternalPayloadReceiver.collcalc": "Collectieve berekeningen",
  "life.enum.ExternalPayloadReceiver.datamart2": "",
  "life.enum.ExternalPayloadReceiver.external": "Extern",
  "life.enum.ExternalPayloadReceiver.legalentity": "Rechtspersoon",
  "life.enum.ExternalPayloadReceiver.life": "Life",
  "life.enum.ExternalPayloadReceiver.moneyin": "Incasso",
  "life.enum.ExternalPayloadReceiver.moneyout": "Excasso",
  "life.enum.ExternalPayloadReceiver.unitlink": "UnitLink",
  "life.enum.ExternalPayloadType.bulkDataExport": "Export bulk gegevens",
  "life.enum.ExternalPayloadType.camt53": "camt.053",
  "life.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "life.enum.ExternalPayloadType.camt54": "camt.054",
  "life.enum.ExternalPayloadType.generalLedger": "Grootboek",
  "life.enum.ExternalPayloadType.migration": "Migratie",
  "life.enum.ExternalPayloadType.namingResponse": "",
  "life.enum.ExternalPayloadType.none": "Geen",
  "life.enum.ExternalPayloadType.pain001": "pain.001",
  "life.enum.ExternalPayloadType.pain002": "pain.002",
  "life.enum.ExternalPayloadType.testTransactionalIn": "Test transactioneel inkomend",
  "life.enum.ExternalPayloadType.testTransactionalOut": "Test transactioneel uitgaand",
  "life.enum.ExternalPayloadType.testin": "Test in",
  "life.enum.ExternalPayloadType.testout": "Test uit",
  "life.enum.FPlusCompletionItemTag.deprecated": "",
  "life.enum.FrameCardinality.one": "One",
  "life.enum.FrameCardinality.oneToMany": "Eén-op-veel",
  "life.enum.FrameCardinality.zeroToMany": "Nul-op-veel",
  "life.enum.FrameCardinality.zeroToOne": "Nul-op-één",
  "life.enum.Gender.Female": "Vrouw",
  "life.enum.Gender.Male": "Man",
  "life.enum.Gender.Unknown": "Onbekend",
  "life.enum.GlAggregationType.correction": "Correctie",
  "life.enum.GlAggregationType.counter": "Teller",
  "life.enum.GlAggregationType.manual": "Handmatig",
  "life.enum.GlAggregationType.normal": "Normaal",
  "life.enum.LifeInsuranceEvent.accident": "Ongeluk",
  "life.enum.LifeInsuranceEvent.criticalIllness": "Kritieke ziekte",
  "life.enum.LifeInsuranceEvent.death": "Overlijden",
  "life.enum.LifeInsuranceEvent.deathOfRelated": "Overlijden gerelateerde",
  "life.enum.LifeInsuranceEvent.disability": "Arbeidsongeschiktheid",
  "life.enum.LifeInsuranceEvent.divorce": "Echtscheiding",
  "life.enum.LifeInsuranceEvent.lossOfLicense": "Verlies van licentie",
  "life.enum.LifeInsuranceEvent.paidUp": "Slaper",
  "life.enum.LifeInsuranceEvent.premiumHoliday": "Premievakantie",
  "life.enum.LifeInsuranceEvent.retirement": "Pensionering",
  "life.enum.LifeInsuranceEvent.surrender": "Afgekocht",
  "life.enum.LifeInsuranceEvent.transferOut": "Uitgaande waardeoverdracht",
  "life.enum.LifeInsuranceEvent.transferOutDivorce": "Uitgaande waardeoverdracht echtscheiding",
  "life.enum.LifeInsuranceEvent.voluntaryContinuation": "Vrijwillge voortzetting",
  "life.enum.LogLevel.all": "Alle",
  "life.enum.LogLevel.debug": "Debug",
  "life.enum.LogLevel.error": "Fouten",
  "life.enum.LogLevel.info": "Info",
  "life.enum.LogLevel.off": "Uit",
  "life.enum.LogLevel.trace": "Trace",
  "life.enum.LogLevel.warn": "Waarschuwing",
  "life.enum.MetaAssociationOutput.aggregation": "Aggregatie",
  "life.enum.MetaAssociationOutput.composition": "Samenstelling",
  "life.enum.MetaCardinalityOutput.many": "Veel",
  "life.enum.MetaCardinalityOutput.one": "Eén",
  "life.enum.MoneyInTaxcode.none": "-",
  "life.enum.MoneyOutPeriodDuration.halfYearly": "Halfjaarlijks",
  "life.enum.MoneyOutPeriodDuration.monthly": "Maandelijks",
  "life.enum.MoneyOutPeriodDuration.quarterly": "Per kwartaal",
  "life.enum.MoneyOutPeriodDuration.single": "Eenmalig",
  "life.enum.MoneyOutPeriodDuration.yearly": "Jaarlijks",
  "life.enum.MoneyOutTaxcode.none": "Geen",
  "life.enum.MoneyOutType.adhoc": "Adhoc",
  "life.enum.MoneyOutType.annuity": "Annuïteit",
  "life.enum.MoneyOutType.lumpsum": "Eenmalige",
  "life.enum.MoneyOutType.wop": "Premievrij",
  "life.enum.MoneyPeriodType.benefit": "Uitkering",
  "life.enum.MoneyPeriodType.saving": "Kapitaal",
  "life.enum.NotificationType.alert": "Alarm",
  "life.enum.NotificationType.info": "Info",
  "life.enum.NotificationType.warning": "Waarschuwing",
  "life.enum.PartnershipType.cohabitant": "Samenwonend",
  "life.enum.PartnershipType.married": "Getrouwd",
  "life.enum.PartnershipType.registeredPartnership": "Geregistreerd partnerschap",
  "life.enum.PolicyCreateType.deathTransformation": "Transformatie overlijden",
  "life.enum.PolicyCreateType.disabilityTransformation": "Transformatie arbeidsongeschiktheid",
  "life.enum.PolicyCreateType.incomingPayment": "Inkomende betaling",
  "life.enum.PolicyCreateType.incomingTransfer": "Inkomende overdracht",
  "life.enum.PolicyCreateType.manual": "Handmatig",
  "life.enum.PolicyCreateType.retirementTransformation": "Transformatie pensionering",
  "life.enum.PolicyProductType.none": "Geen",
  "life.enum.PolicyStatus.contribution": "Premiebetalend",
  "life.enum.PolicyStatus.death": "Overlijden",
  "life.enum.PolicyStatus.disabled": "Arbeidsongeschikt",
  "life.enum.PolicyStatus.disbursement": "Uitkerend",
  "life.enum.PolicyStatus.none": "Geen",
  "life.enum.PolicyStatus.paidUp": "Slaper",
  "life.enum.PolicyStatus.premiumHoliday": "Premievakantie",
  "life.enum.PolicyStatus.retired": "Gepensioneerd",
  "life.enum.PolicyStatus.surrended": "Afgekocht",
  "life.enum.PolicyStatus.terminated": "Beëindigd",
  "life.enum.PolicyTerminateType.death": "Overlijden",
  "life.enum.PolicyTerminateType.merge": "Samenvoegen",
  "life.enum.PolicyTerminateType.outgoingTransfer": "Uitgaande overdracht",
  "life.enum.PolicyTerminateType.policyEnd": "Einde polis",
  "life.enum.PolicyTerminateType.retirement": "Pensionering",
  "life.enum.PolicyTerminateType.surrender": "Afgekocht",
  "life.enum.PostingTable.BP": "Balansboekingstabel",
  "life.enum.PostingTable.OPP": "Open boekingstabel",
  "life.enum.PostingType.balanceFromUnitlink": "Saldo van UnitLink",
  "life.enum.PostingType.balanceToUnitLink": "Saldo naar UnitLink",
  "life.enum.PostingType.billing": "Veronderstelde premies",
  "life.enum.PostingType.billingRequest": "Factureringsverzoek",
  "life.enum.PostingType.closeSubPortfolio": "Sluit sub-portfolio",
  "life.enum.PostingType.closedSubPortfolioReturnFromUnitlink": "Gesloten sub-portfolio retour van UnitLink",
  "life.enum.PostingType.costFromUnitLink": "Kosten van UnitLink",
  "life.enum.PostingType.coverTransferredToUnitLinkCounterpost": "Dekking overgedragen naar UnitLink tegenboeking",
  "life.enum.PostingType.coverTransferredToUnitLinkWithNoTradeCosts": "Dekking overgedragen naar UnitLink zonder handelskosten",
  "life.enum.PostingType.coverTransferrredToUnitLink": "Dekking overgedragen naar UnitLink",
  "life.enum.PostingType.employmentIn": "Dienstverband",
  "life.enum.PostingType.endEmploymentToUnitlink": "Einde dienstverband naar UnitLink",
  "life.enum.PostingType.fixSentToUnitlinkFromState": "Herstel verzending naar UnitLink vanuit status",
  "life.enum.PostingType.fundCostFromUnitlink": "Fondskosten vanuit UnitLink",
  "life.enum.PostingType.glRounding": "Afronding grootboek",
  "life.enum.PostingType.glRoundingExcluded": "Uitgesloten grootboekafronding",
  "life.enum.PostingType.internalBalanceTransfer": "Interne saldo overdrachten",
  "life.enum.PostingType.internalTransferBetweenCommitments": "Interne waardeoverdracht",
  "life.enum.PostingType.internalTransferBetweenDims": "Interne waardeoverdracht",
  "life.enum.PostingType.migrationBalance": "Migratie balans",
  "life.enum.PostingType.moneyIn": "Incasso",
  "life.enum.PostingType.moneyOut": "Excasso",
  "life.enum.PostingType.moneyOutNoProofOfLife": "Uitgaande betaling zonder bewijs van in leven zijn",
  "life.enum.PostingType.moneyOutNoSignOfLife": "Uitgaande betaling zonder levensteken",
  "life.enum.PostingType.moveBalanceFromUnitLink": "Verplaatsen saldo van UnitLink",
  "life.enum.PostingType.moveBalanceNotInvestedToUnitLink": "Verplaatsen niet-geïnvesteerd saldo naar UnitLink",
  "life.enum.PostingType.moveBalanceToUnitLink": "Verplaatsen saldo naar UnitLink",
  "life.enum.PostingType.newCoverToUnitLink": "Nieuwe dekking naar UnitLink",
  "life.enum.PostingType.none": "Geen",
  "life.enum.PostingType.payloadRejected": "Payload afgewezen",
  "life.enum.PostingType.receivedInternalTransferBetweenCommitments": "Interne overdracht tussen verplichtingen ontvangen",
  "life.enum.PostingType.requestBalanceUpdate": "Vraag balans update",
  "life.enum.PostingType.reserveJumpDeath": "Reserve sprong dood",
  "life.enum.PostingType.reserveJumpDisability": "Reserve sprong arbeidsongeschiktheid",
  "life.enum.PostingType.revertSendEndEmploymentToUnitLink": "Terugdraaien verzending einde dienstverband naar UnitLink",
  "life.enum.PostingType.revertSendMoveBalanceToUnitLink": "Terugdraaien verplaatsen saldo naar UnitLink",
  "life.enum.PostingType.revertSendNewCoverToUnitLink": "Terugdraaien nieuwe dekking naar UnitLink",
  "life.enum.PostingType.revertSendStartEmploymentToUnitLink": "Terugdraaien start dienstverband naar UnitLink",
  "life.enum.PostingType.revertSendUnitLinkSubPortfolioClose": "Terugdraaien verplaatsen gesloten UnitLink sub-portfolio",
  "life.enum.PostingType.riskPremiumDeath": "Risicopremie overlijden",
  "life.enum.PostingType.riskPrmSurvival": "Risico premie overleving",
  "life.enum.PostingType.rounding": "Afronding",
  "life.enum.PostingType.sendBalanceToUnitLink": "Verplaatsen saldo naar UnitLink",
  "life.enum.PostingType.sendEndEmploymentToUnitLink": "Verzenden einde dienstverband naar UnitLink",
  "life.enum.PostingType.sendMoveBalanceNotInvestedToUnitLink": "Verstuur niet-geïnvesteerd saldo naar UnitLink",
  "life.enum.PostingType.sendMoveBalanceToUnitLink": "Verstuur saldo naar UnitLink",
  "life.enum.PostingType.sendNewCoverToUnitLink": "Stuur een nieuwe hoes naar UnitLink",
  "life.enum.PostingType.sendStartEmploymentToUnitLink": "Verzenden start dienstverband naar UnitLink",
  "life.enum.PostingType.sendUnitLinkSubPortfolioClose": "Verplaatsen gesloten UnitLink sub-portfolio",
  "life.enum.PostingType.sentInternalTransferBetweenCommitments": "Verplaatsen interne overdracht tussen toezeggingen",
  "life.enum.PostingType.sentMoneyOut": "Verplaatsen excasso",
  "life.enum.PostingType.sentValueTransferOut": "Verplaatsen uitgaande waardeoverdracht",
  "life.enum.PostingType.startEmploymentToUnitLink": "Start dienstverband naar UnitLink",
  "life.enum.PostingType.tradeCostFromUnitlink": "Handelskosten vanuit UnitLink",
  "life.enum.PostingType.transferSentToUnitlinkBetweenCovers": "Overdracht verzonden naar UnitLink tussen dekkingen",
  "life.enum.PostingType.unitLinkSubPortfolioClose": "Gesloten UnitLink sub-portfolio",
  "life.enum.PostingType.usedValueTransferIn": "Gebruikte inkomende waardeoverdracht",
  "life.enum.PostingType.valuationPrmBilling": "Waarderingspremie facturering",
  "life.enum.PostingType.valuationResidual": "Waardering van de restwaarde",
  "life.enum.PostingType.valueTransferIn": "Inkomende waardeoverdracht",
  "life.enum.PostingType.valueTransferOut": "Uitgaande waardeoverdracht",
  "life.enum.PostingType.writeOff": "Afschrijving",
  "life.enum.PostingType.yield": "Rendement",
  "life.enum.PostingType.yieldAfterMoveFromUnitLink": "Rendement na verplaatsing van UnitLink",
  "life.enum.PostingType.yieldFromUnitLink": "Rendement van UnitLink",
  "life.enum.PremiumHolidayType.none": "Geen",
  "life.enum.ProfileType.individualProfile": "Individueel profiel",
  "life.enum.ProfileType.lifeCycleProfile": "Levenscyclusprofiel",
  "life.enum.ProjectionType.nearTimeSimulation": "",
  "life.enum.ProjectionType.none": "Geen",
  "life.enum.RelationshipType.child": "Kind",
  "life.enum.RelationshipType.cohabitant": "Samenwonend",
  "life.enum.RelationshipType.none": "Geen",
  "life.enum.RelationshipType.registeredPartner": "Geregistreerde partner",
  "life.enum.RelationshipType.spouse": "Echtgenoot",
  "life.enum.ReportType.none": "Geen",
  "life.enum.ReportingEventType.cancelled": "",
  "life.enum.ReportingEventType.newReport": "",
  "life.enum.ReportingEventType.reported": "",
  "life.enum.ReportingEventType.update": "",
  "life.enum.SavingsTaxcode.none": "Geen",
  "life.enum.TenantSubGroup.none": "Geen",
  "life.enum.TestBatchSpecificationType.faulty": "Defect",
  "life.enum.TestBatchSpecificationType.noop": "Noop",
  "life.enum.TestBatchSpecificationType.normal": "Normaal",
  "life.enum.UnitlinkStatus.inUnitlink": "In UnitLink",
  "life.enum.UnitlinkStatus.leavingUnitlink": "UnitLink verlaten",
  "life.enum.UnitlinkStatus.notInUnitlink": "Niet in UnitLink",
  "life.enum.UnitlinkStatus.notInvestedInUnitlink": "Niet belegd in UnitLink",
  "life.enum.VoluntaryContributionPlacement.none": "Geen",
  "moneyIn.enum.AccountType.bankShadow": "Schaduw bank",
  "moneyIn.enum.AccountType.billedFees": "Gefactureerde vergoedingen",
  "moneyIn.enum.AccountType.completedInvoices": "Betaalde facturen",
  "moneyIn.enum.AccountType.convertedHistoricContributions": "Geconverteerde historische bijdragen",
  "moneyIn.enum.AccountType.convertedShadow": "Geconverteerde schaduw",
  "moneyIn.enum.AccountType.distributedPayments": "Gedistribueerde betalingen",
  "moneyIn.enum.AccountType.employerAssumedPayments": "Werkgever veronderstelde betalingen",
  "moneyIn.enum.AccountType.employerBilling": "Facturen werkgever",
  "moneyIn.enum.AccountType.employerBillingRequest": "Verzoek facturen werkgever",
  "moneyIn.enum.AccountType.employerContributions": "Betalingen werkgever",
  "moneyIn.enum.AccountType.employerReceivables": "Vorderingen werkgever",
  "moneyIn.enum.AccountType.externalShadow": "Externe schaduw",
  "moneyIn.enum.AccountType.infoServiceReconcile": onlyInDanishLayerForNow,
  "moneyIn.enum.AccountType.infoServiceReturns": onlyInDanishLayerForNow,
  "moneyIn.enum.AccountType.invoiceElements": "Factuur elementen",
  "moneyIn.enum.AccountType.invoicePayments": "Factuur betalingen",
  "moneyIn.enum.AccountType.invoicesLifeShadow": "Life schaduw facturen",
  "moneyIn.enum.AccountType.lifeShadow": "Life schaduw",
  "moneyIn.enum.AccountType.moneyOutShadow": "Excasso schaduw",
  "moneyIn.enum.AccountType.none": "Geen",
  "moneyIn.enum.AccountType.paidFees": "Betaalde vergoedingen",
  "moneyIn.enum.AccountType.payments": "Betalingen",
  "moneyIn.enum.AccountType.pendingBilling": "Facturering in behandeling",
  "moneyIn.enum.AccountType.pendingTransitContributions": "Bijdragen onderweg in behandeling",
  "moneyIn.enum.AccountType.personBillingRequest": "Verzoek facturering persoon",
  "moneyIn.enum.AccountType.personContributions": "Bijdragen persoon",
  "moneyIn.enum.AccountType.personPrivateBillings": "Persoonlijke facturen",
  "moneyIn.enum.AccountType.personReceivables": "Vorderingen persoon",
  "moneyIn.enum.AccountType.receivables": "Vorderingen",
  "moneyIn.enum.AccountType.rounding": "Afronding",
  "moneyIn.enum.AccountType.sentBillings": "Verzonden facturen",
  "moneyIn.enum.AccountType.toLife": "Naar life",
  "moneyIn.enum.AccountType.toMoneyOut": "Naar excasso",
  "moneyIn.enum.AccountType.transitContributions": "Bijdragen onderweg",
  "moneyIn.enum.AccountType.unclaimedPayments": "Niet geclaimde betalingen",
  "moneyIn.enum.AccountType.undistributedPayments": "Niet verdeelde betalingen",
  "moneyIn.enum.AccountType.undistributedReceivables": "Niet verdeelde vorderingen",
  "moneyIn.enum.AccountType.unrelatedPaymentsShadow": "Schaduwrekening niet-gerelateerde betalingen",
  "moneyIn.enum.AccountType.upcomingBillings": "Komende facturen",
  "moneyIn.enum.AccountType.writeOffShadow": "Afschrijving schaduw",
  "moneyIn.enum.BankAccountKind.Iban": "IBAN",
  "moneyIn.enum.BankAccountKind.Other": "Anders",
  "moneyIn.enum.BatchStatusType.completed": "Voltooid",
  "moneyIn.enum.BatchStatusType.created": "Aangemaakt",
  "moneyIn.enum.BatchStatusType.failed": "Mislukt",
  "moneyIn.enum.BatchStatusType.started": "Gestart",
  "moneyIn.enum.BatchStatusType.stopped": "Gestopt",
  "moneyIn.enum.BillingChannel.bS": "Facturatiekanaal",
  "moneyIn.enum.BillingFrequency.halfyear": "Halfjaarlijks",
  "moneyIn.enum.BillingFrequency.month": "Maandelijks",
  "moneyIn.enum.BillingFrequency.quarter": "Per kwartaal",
  "moneyIn.enum.BillingFrequency.year": "Jaarlijks",
  "moneyIn.enum.BillingMethodType.none": "Geen",
  "moneyIn.enum.BulkDataType.Accounts": "",
  "moneyIn.enum.BulkDataType.BalancePostings": "",
  "moneyIn.enum.BulkDataType.Enums": "",
  "moneyIn.enum.BulkDataType.OpenPostPostings": "",
  "moneyIn.enum.BulkDataType.ParameterValueIntervals": "",
  "moneyIn.enum.BulkDataType.ParameterValues": "",
  "moneyIn.enum.BulkDataType.TariffTemplates": "",
  "moneyIn.enum.BulkDataType.Tenants": "",
  "moneyIn.enum.BulkDataType.WorkPads": "",
  "moneyIn.enum.BusinessType.company": "",
  "moneyIn.enum.BusinessType.person": "",
  "moneyIn.enum.CommandGroupType.advance": "Doorgaan",
  "moneyIn.enum.CommandGroupType.annotation": "Annotatie",
  "moneyIn.enum.CommandGroupType.calculation": "Berekening",
  "moneyIn.enum.CommandGroupType.employerAgreement": "Werkgeversovereenkomst",
  "moneyIn.enum.CommandGroupType.employment": "Dienstverband",
  "moneyIn.enum.CommandGroupType.invoice": "Factuur",
  "moneyIn.enum.CommandGroupType.legalEntity": "Rechtspersoon",
  "moneyIn.enum.CommandGroupType.moneyIn": "Incasso",
  "moneyIn.enum.CommandGroupType.moneyOut": "Excasso",
  "moneyIn.enum.CommandGroupType.none": "Geen",
  "moneyIn.enum.CommandGroupType.policyChange": "Wijzig polis",
  "moneyIn.enum.CommandGroupType.posting": "Boekingen",
  "moneyIn.enum.CommandGroupType.tax": "Belasting",
  "moneyIn.enum.CommandGroupType.unitlink": "UnitLink",
  "moneyIn.enum.CommandType.addAccessGroupAnnotation": "Toevoegen annotatie",
  "moneyIn.enum.CommandType.addInvoiceToInstallmentPlan": "Factuur toevoegen aan betalingsregeling",
  "moneyIn.enum.CommandType.addPaymentInvoice": "Toevoegen factuur",
  "moneyIn.enum.CommandType.amendAccessGroupAnnotation": "Wijzigen annotatie",
  "moneyIn.enum.CommandType.autoPauseInvoice": "Automatisch pauzeren factuur",
  "moneyIn.enum.CommandType.cancelInvoice": "Annuleren factuur",
  "moneyIn.enum.CommandType.createInvoice": "Aanmaken factuur",
  "moneyIn.enum.CommandType.creditPaymentInvoice": "Credit factuur",
  "moneyIn.enum.CommandType.defaultTemplate": "Standaard sjabloon",
  "moneyIn.enum.CommandType.disablePenaltiesInvoice": "Boetes voor factuur uitschakelen",
  "moneyIn.enum.CommandType.pauseInvoice": "Pauzeren factuur",
  "moneyIn.enum.CommandType.reconcileInvoice": "Afletteren factuur",
  "moneyIn.enum.CommandType.removeAccessGroupAnnotation": "Verwijderen annotatie",
  "moneyIn.enum.CommandType.removeInvoiceFromInstallmentPlan": "Factuur uit betalingsregeling verwijderen",
  "moneyIn.enum.CommandType.resumeInvoice": "Hervatten factuur",
  "moneyIn.enum.CommandType.resumeInvoiceWithNextOperation": "Hervatten factuur met volgende operatie",
  "moneyIn.enum.CommandType.triggeredPauseInvoice": "Getriggerde factuurpauze",
  "moneyIn.enum.CommandType.withdrawPaymentInvoice": "Intrekken betalingsfactuur",
  "moneyIn.enum.CommandType.writeOffInvoice": "Afschrijven factuur",
  "moneyIn.enum.CompanyStatus.none": "Geen",
  "moneyIn.enum.ConfigurationEntityType.EnumDefinition": "",
  "moneyIn.enum.ConfigurationEntityType.EnumLiteral": "",
  "moneyIn.enum.ConfigurationEntityType.GlMap": "",
  "moneyIn.enum.ConfigurationEntityType.ParameterDefinition": "",
  "moneyIn.enum.ConfigurationEntityType.ParameterValue": "",
  "moneyIn.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "moneyIn.enum.ConfigurationEntityType.RegisteredTenant": "",
  "moneyIn.enum.ConfigurationEntityType.Template": "",
  "moneyIn.enum.DataSubscriptionRoleType.unspecified": "",
  "moneyIn.enum.ExternalPayloadProcessStatusType.deleted": "Verwijderd",
  "moneyIn.enum.ExternalPayloadProcessStatusType.processed": "Verwerkt",
  "moneyIn.enum.ExternalPayloadProcessStatusType.registered": "Geregistreerd",
  "moneyIn.enum.ExternalPayloadProcessStatusType.rejected": "Afgewezen",
  "moneyIn.enum.ExternalPayloadProcessStatusType.sent": "Verzonden",
  "moneyIn.enum.ExternalPayloadProcessStatusType.unsent": "Niet verzonden",
  "moneyIn.enum.ExternalPayloadReceiver.collcalc": "Collectieve berekeningen",
  "moneyIn.enum.ExternalPayloadReceiver.datamart2": "",
  "moneyIn.enum.ExternalPayloadReceiver.external": "Extern",
  "moneyIn.enum.ExternalPayloadReceiver.legalentity": "Rechtspersoon",
  "moneyIn.enum.ExternalPayloadReceiver.life": "Life",
  "moneyIn.enum.ExternalPayloadReceiver.moneyin": "Incasso",
  "moneyIn.enum.ExternalPayloadReceiver.moneyout": "Excasso",
  "moneyIn.enum.ExternalPayloadReceiver.unitlink": "UnitLink",
  "moneyIn.enum.ExternalPayloadType.bulkDataExport": "",
  "moneyIn.enum.ExternalPayloadType.camt53": "camt.053",
  "moneyIn.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "moneyIn.enum.ExternalPayloadType.camt54": "camt.054",
  "moneyIn.enum.ExternalPayloadType.generalLedger": "Grootboek",
  "moneyIn.enum.ExternalPayloadType.migration": "Migratie",
  "moneyIn.enum.ExternalPayloadType.moneyInConversion": "Conversie incasso",
  "moneyIn.enum.ExternalPayloadType.namingResponse": "",
  "moneyIn.enum.ExternalPayloadType.netAxept": onlyInDanishLayerForNow,
  "moneyIn.enum.ExternalPayloadType.none": "Geen",
  "moneyIn.enum.ExternalPayloadType.pain001": "pain.001",
  "moneyIn.enum.ExternalPayloadType.pain002": "pain.002",
  "moneyIn.enum.ExternalPayloadType.testTransactionalIn": "",
  "moneyIn.enum.ExternalPayloadType.testTransactionalOut": "",
  "moneyIn.enum.ExternalPayloadType.testin": "Test in",
  "moneyIn.enum.ExternalPayloadType.testout": "Test uit",
  "moneyIn.enum.ExternalPaymentDirectDebitType.crossBorder": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.intraCompany": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.none": "Geen",
  "moneyIn.enum.ExternalPaymentDirectDebitType.sepaB2b": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.sepaCore": "",
  "moneyIn.enum.ExternalPaymentDirectDebitType.unpaid": "",
  "moneyIn.enum.FPlusCompletionItemTag.deprecated": "",
  "moneyIn.enum.Gender.Female": "",
  "moneyIn.enum.Gender.Male": "",
  "moneyIn.enum.Gender.Unknown": "",
  "moneyIn.enum.GlAggregationType.correction": "Correctie",
  "moneyIn.enum.GlAggregationType.counter": "Teller",
  "moneyIn.enum.GlAggregationType.manual": "Handmatig",
  "moneyIn.enum.GlAggregationType.normal": "Normaal",
  "moneyIn.enum.InvoiceBundlingPenaltyType.none": "Geen",
  "moneyIn.enum.InvoicePayerType.Company": "Bedrijf",
  "moneyIn.enum.InvoicePayerType.Person": "Persoon",
  "moneyIn.enum.InvoiceStatus.billed": "Gefactureerd",
  "moneyIn.enum.InvoiceStatus.cancelled": "Geannuleerd",
  "moneyIn.enum.InvoiceStatus.created": "Aangemaakt",
  "moneyIn.enum.InvoiceStatus.reconciled": "Geconsolideerd",
  "moneyIn.enum.InvoiceStatus.reminded": "Herinnerd",
  "moneyIn.enum.InvoiceStatus.terminated": "Beëindigd",
  "moneyIn.enum.InvoiceTerminationAction.ignore": "Negeren",
  "moneyIn.enum.InvoiceTerminationAction.reverse": "Terugdraaien",
  "moneyIn.enum.InvoiceTerminationAction.writeOff": "Afschrijven",
  "moneyIn.enum.InvoiceType.installmentPlanInvoice": "Afbetalingsplan ",
  "moneyIn.enum.InvoiceWriteOffCategory.none": "Geen",
  "moneyIn.enum.InvoiceWriteOffType.automatic": "Automatisch",
  "moneyIn.enum.InvoiceWriteOffType.manual": "Handmatig",
  "moneyIn.enum.LogLevel.all": "Alle",
  "moneyIn.enum.LogLevel.debug": "Debug",
  "moneyIn.enum.LogLevel.error": "Fouten",
  "moneyIn.enum.LogLevel.info": "Info",
  "moneyIn.enum.LogLevel.off": "Uit",
  "moneyIn.enum.LogLevel.trace": "Trace",
  "moneyIn.enum.LogLevel.warn": "Waarschuwingen",
  "moneyIn.enum.MetaAssociationOutput.aggregation": "Aggregatie",
  "moneyIn.enum.MetaAssociationOutput.composition": "Samenstelling",
  "moneyIn.enum.MetaCardinalityOutput.many": "Veel",
  "moneyIn.enum.MetaCardinalityOutput.one": "Eén",
  "moneyIn.enum.PayerMapUpdateCause.api": "",
  "moneyIn.enum.PayerMapUpdateCause.incomingPayment": "",
  "moneyIn.enum.PaymentOwnerType.company": "",
  "moneyIn.enum.PaymentOwnerType.none": "Geen",
  "moneyIn.enum.PaymentOwnerType.person": "",
  "moneyIn.enum.PaymentReceiverType.Account": "Account",
  "moneyIn.enum.PaymentReceiverType.LegalEntity": "Rechtspersoon",
  "moneyIn.enum.PaymentReceiverType.PaymentSender": "Afzender betaling",
  "moneyIn.enum.PaymentStatus.closed": "Closed",
  "moneyIn.enum.PaymentStatus.open": "Open",
  "moneyIn.enum.PaymentType.directDebitBatch": "Directe incasso batch",
  "moneyIn.enum.PaymentType.unrelatedPayment": "Onverwante betaling",
  "moneyIn.enum.PostingTable.BP": "Balansboekingstabel",
  "moneyIn.enum.PostingTable.OPP": "Open boekingstabel",
  "moneyIn.enum.PostingType.approvedEmployeeContribution": "Goedgekeurde werknemersbijdrage",
  "moneyIn.enum.PostingType.approvedNetAxeptContribution": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.approvedPrivateBillingPaymentEntry": "Goedgekeurde betalingsboeking particuliere facturering",
  "moneyIn.enum.PostingType.approvedTransitEmployeeContribution": "Goedgekeurde doorvoerwerknemersbijdrage",
  "moneyIn.enum.PostingType.billingPaymentEntry": "Invoer betaling facturatie",
  "moneyIn.enum.PostingType.cancelledBilling": "Geannuleerde facturering",
  "moneyIn.enum.PostingType.cancelledPrivateBilling": "Persoonlijke facturen geannuleerd",
  "moneyIn.enum.PostingType.convertedHistoricContribution": "Geconverteerde historische bijdragen",
  "moneyIn.enum.PostingType.directDebitInvoicePayment": "Betaling van facturen via automatische incasso",
  "moneyIn.enum.PostingType.directDebitInvoicePaymentCancellation": "Annulering betaling van facturen via automatische incasso",
  "moneyIn.enum.PostingType.directDebitPayment": "Automatische incasso",
  "moneyIn.enum.PostingType.directDebitPaymentSpec": "Specificatie van de automatische incassobetaling",
  "moneyIn.enum.PostingType.directDebitPaymentSpecEntry": "Invoer specificatie van de automatische incassobetaling",
  "moneyIn.enum.PostingType.directDebitPaymentSpecEntryReconcile": "Afstemming invoer specificatie van de automatische incassobetaling",
  "moneyIn.enum.PostingType.directDebitPaymentSpecReconcile": "Afstemming inover specificatie van de automatische incassobetaling",
  "moneyIn.enum.PostingType.employeeBilling": "Facturatie werknemer",
  "moneyIn.enum.PostingType.employeeBillingReconcile": "Reconciliatie facturen werknemer",
  "moneyIn.enum.PostingType.employeeContribution": "Bijdrage werknemer",
  "moneyIn.enum.PostingType.employeeReceivablesSpec": "Specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.employeeReceivablesSpecReconcile": "Reconciliatie specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.employerBilling": "Facturatie werkgever",
  "moneyIn.enum.PostingType.employerContribution": "Bijdrage werkgever",
  "moneyIn.enum.PostingType.employerReceivablesSpec": "Specificatie vorderingen werkgever",
  "moneyIn.enum.PostingType.employerReceivablesSpecDistribution": "Specificatie verdeling vorderingen werkgever",
  "moneyIn.enum.PostingType.employerReceivablesSpecReconcile": "Reconciliatie specificatie vorderingen werkgever",
  "moneyIn.enum.PostingType.externallyHandledEmployeeContribution": "Extern verwerkte werknemersbijdrage",
  "moneyIn.enum.PostingType.externallyHandledEmployerContribution": "Extern verwerkte werkgeversbijdrage",
  "moneyIn.enum.PostingType.glRounding": "Afronding grootboek",
  "moneyIn.enum.PostingType.glRoundingExcluded": "Uitgesloten grootboekafronding",
  "moneyIn.enum.PostingType.incomingValueTransfer": "Inkomende waardeoverdracht",
  "moneyIn.enum.PostingType.incomingValueTransferReconcile": "Reconciliatie inkomende waardeoverdracht",
  "moneyIn.enum.PostingType.infoServiceContribution": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.infoServicePayment": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.infoServicePaymentSpec": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.infoServicePaymentSpecReconcile": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.installmentPlanBilling": "Facturering betalingsregeling",
  "moneyIn.enum.PostingType.installmentPlanBillingBundled": "Gebundelde facturering betalingsregeling",
  "moneyIn.enum.PostingType.invalidEmployeeReceivablesSpec": "Ongeldige specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.invalidManualEmployeeReceivablesSpec": "Ongeldige handmatige specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.invoiceBundlingPenalty": "Boete voor bundeling facturen",
  "moneyIn.enum.PostingType.invoicePaymentRedistribution": "Herverdeling factuurbetaling",
  "moneyIn.enum.PostingType.invoiceTermination": "Beëindiging factuur",
  "moneyIn.enum.PostingType.invoiceWriteOff": "Afschrijving factuur",
  "moneyIn.enum.PostingType.manualContribution": "Handmatige bijdrage",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpec": "Handmatige specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecDelete": "Verwijderde handmatige specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecEdit": "Bewerkte handmatige specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.manualEmployeeReceivablesSpecReconcile": "Reconciliatie specificatie vorderingen werknemer",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpec": "Handmatige specificatie vorderingen werkgever",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecDistribution": "Handmatige specificatie verdeling vorderingen werkgever",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecEdit": "Gewijzigde specificatie vorderingen werkgever",
  "moneyIn.enum.PostingType.manualEmployerReceivablesSpecEditDistribution": "Gewijzigde specificatie verdeling vorderingen werkgever",
  "moneyIn.enum.PostingType.manualPayment": "Handmatige betaling",
  "moneyIn.enum.PostingType.manualPaymentSpec": "Specificatie handmatige betaling",
  "moneyIn.enum.PostingType.manualPaymentSpecReconcile": "Reconciliatie specificatie handmatige betaling",
  "moneyIn.enum.PostingType.manualReturnEmployeeContribution": "Handmatige terugbetaling werknemersbijdrage",
  "moneyIn.enum.PostingType.netAxeptContribution": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.netAxeptPayment": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.netAxeptPaymentSpec": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.netAxeptPaymentSpecEntry": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.netAxeptPaymentSpecEntryReconcile": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.netAxeptPaymentSpecReconcile": onlyInDanishLayerForNow,
  "moneyIn.enum.PostingType.none": "Geen",
  "moneyIn.enum.PostingType.paidInvoiceBundlingPenalty": "Betaalde boete voor bundeling facturen",
  "moneyIn.enum.PostingType.paymentCredit": "Credit betaling",
  "moneyIn.enum.PostingType.pensionTransfer": "Pensioenoverdracht",
  "moneyIn.enum.PostingType.personPrivateBilling": "Privé persoon facturatie",
  "moneyIn.enum.PostingType.personPrivateBillingReconcile": "Reconciliatie privé persoon facturatie",
  "moneyIn.enum.PostingType.privateBilling": "Particuliere facturatie",
  "moneyIn.enum.PostingType.privateBillingPaymentEntry": "Betalingsboeking particuliere facturering",
  "moneyIn.enum.PostingType.privateBillingReconcile": "Reconciliatie particuliere facturatie",
  "moneyIn.enum.PostingType.privateReminder": "Particuliere herinnering",
  "moneyIn.enum.PostingType.reminderFee": "Herinneringskosten",
  "moneyIn.enum.PostingType.returnedContribution": "Teruggegeven bijdrage",
  "moneyIn.enum.PostingType.transitContributionOut": "Uitgaande doorvoerbijdrage",
  "moneyIn.enum.PostingType.transitEmployeeContribution": "Doorvoerwerknemersbijdrage",
  "moneyIn.enum.PostingType.transitEmployeeReceivablesSpec": "Specificatie doorvoerwerknemersvordering",
  "moneyIn.enum.PostingType.transitEmployeeReceivablesSpecReconcile": "Afstemming specificatie doorvoerwerknemersvordering",
  "moneyIn.enum.PostingType.unexpectedCancelledPrivateBilling": "Onverwachte geannuleerde particuliere facturatie",
  "moneyIn.enum.PostingType.unknownPayment": "Onbekende betaling",
  "moneyIn.enum.PostingType.unrelatedPayment": "Niet-gerelateerde betaling",
  "moneyIn.enum.PostingType.voluntaryContribution": "Vrijwillig bijdrage",
  "moneyIn.enum.PostingType.withdrawnContribution": "Ingetrokken bijdrage",
  "moneyIn.enum.ReportType.none": "Geen",
  "moneyIn.enum.ReportingEventType.cancelled": "",
  "moneyIn.enum.ReportingEventType.newReport": "",
  "moneyIn.enum.ReportingEventType.reported": "",
  "moneyIn.enum.ReportingEventType.update": "",
  "moneyIn.enum.TestBatchSpecificationType.faulty": "Defect",
  "moneyIn.enum.TestBatchSpecificationType.noop": "Noop",
  "moneyIn.enum.TestBatchSpecificationType.normal": "Normaal",
  "moneyIn.enum.UnexpectedInvoicePaymentType.excessAmount": "Overtollig bedrag",
  "moneyIn.enum.UnexpectedInvoicePaymentType.insufficientAmount": "Onvoldoende bedrag",
  "moneyIn.enum.UnrelatedPaymentType.none": "Geen",
  "moneyIn.enum.ValidationStatus.invalid": "Ongeldig",
  "moneyIn.enum.ValidationStatus.unknown": "Onbekend",
  "moneyIn.enum.ValidationStatus.valid": "Geldig",
  "moneyIn.enum.ValueTransferType.none": "Geen",
  "moneyIn.enum.VoluntaryContributionPlacement.none": "Geen",
  "moneyIn.enum.VoluntaryContributionType.oneTime": "Eenmalig",
  "moneyIn.enum.VoluntaryContributionType.recurring": "Terugkerend",
  "moneyOut.enum.AccountType.approvedPayables": "Goedgekeurde verschuldigde bedragen",
  "moneyOut.enum.AccountType.bankShadow": "Schaduw bank",
  "moneyOut.enum.AccountType.convertedHistoricPayments": "Geconverteerde historische betalingen",
  "moneyOut.enum.AccountType.convertedShadow": "Geconverteerde schaduw",
  "moneyOut.enum.AccountType.externalHandlingShadow": "Extern verwerking schaduw",
  "moneyOut.enum.AccountType.failedPayments": "Mislukte betalingen",
  "moneyOut.enum.AccountType.lifeShadow": "Life schaduw",
  "moneyOut.enum.AccountType.moneyInShadow": "Money in schaduw",
  "moneyOut.enum.AccountType.none": "Geen",
  "moneyOut.enum.AccountType.payableElements": "",
  "moneyOut.enum.AccountType.paymentRegulationBalance": "",
  "moneyOut.enum.AccountType.payments": "Betalingen",
  "moneyOut.enum.AccountType.pendingPayables": "Verschuldigde bedragen in behandeling",
  "moneyOut.enum.AccountType.pendingPayments": "Betalingen in behandeling",
  "moneyOut.enum.AccountType.rounding": "",
  "moneyOut.enum.AccountType.taxBalance": "Saldo belasting",
  "moneyOut.enum.AccountType.toLife": "Naar Life",
  "moneyOut.enum.AccountType.writeOffShadow": "Afschrijving schaduw",
  "moneyOut.enum.AuditLogEventType.create": "Aanmaken",
  "moneyOut.enum.AuditLogEventType.read": "Lezen",
  "moneyOut.enum.AuditLogEventType.update": "Update",
  "moneyOut.enum.BankAccountKind.Iban": "IBAN",
  "moneyOut.enum.BankAccountKind.Other": "Anders",
  "moneyOut.enum.BatchStatusType.completed": "Voltooid",
  "moneyOut.enum.BatchStatusType.created": "Aangemaakt",
  "moneyOut.enum.BatchStatusType.failed": "Mislukt",
  "moneyOut.enum.BatchStatusType.started": "Gestart",
  "moneyOut.enum.BatchStatusType.stopped": "Gestopt",
  "moneyOut.enum.BillingChannel.bS": "Facturatiekanaal",
  "moneyOut.enum.BillingFrequency.halfyear": "Halfjaarlijks",
  "moneyOut.enum.BillingFrequency.month": "Maandelijks",
  "moneyOut.enum.BillingFrequency.quarter": "Per kwartaal",
  "moneyOut.enum.BillingFrequency.year": "Jaarlijks",
  "moneyOut.enum.BulkDataType.Accounts": "",
  "moneyOut.enum.BulkDataType.BalancePostings": "",
  "moneyOut.enum.BulkDataType.Enums": "",
  "moneyOut.enum.BulkDataType.OpenPostPostings": "",
  "moneyOut.enum.BulkDataType.ParameterValueIntervals": "",
  "moneyOut.enum.BulkDataType.ParameterValues": "",
  "moneyOut.enum.BulkDataType.TariffTemplates": "",
  "moneyOut.enum.BulkDataType.Tenants": "",
  "moneyOut.enum.BulkDataType.WorkPads": "",
  "moneyOut.enum.BusinessType.company": "",
  "moneyOut.enum.BusinessType.person": "",
  "moneyOut.enum.CommandGroupType.advance": "",
  "moneyOut.enum.CommandGroupType.annotation": "",
  "moneyOut.enum.CommandGroupType.calculation": "",
  "moneyOut.enum.CommandGroupType.employerAgreement": "",
  "moneyOut.enum.CommandGroupType.employment": "",
  "moneyOut.enum.CommandGroupType.legalEntity": "",
  "moneyOut.enum.CommandGroupType.moneyIn": "",
  "moneyOut.enum.CommandGroupType.moneyOut": "",
  "moneyOut.enum.CommandGroupType.none": "Geen",
  "moneyOut.enum.CommandGroupType.policyChange": "",
  "moneyOut.enum.CommandGroupType.posting": "",
  "moneyOut.enum.CommandGroupType.tax": "",
  "moneyOut.enum.CommandGroupType.unitlink": "",
  "moneyOut.enum.CommandType.addAccessGroupAnnotation": "Toevoegen annotatie",
  "moneyOut.enum.CommandType.addPayableStop": "Betalingsstop toevoegen",
  "moneyOut.enum.CommandType.addPaymentChannel": "Uitbetalingskanaal toevoegen",
  "moneyOut.enum.CommandType.amendAccessGroupAnnotation": "Wijzigen annotatie",
  "moneyOut.enum.CommandType.createPaymentReceiver": "Uitbetalingsontvanger aanmaken",
  "moneyOut.enum.CommandType.defaultTemplate": "Standaardsjabloon",
  "moneyOut.enum.CommandType.deletePayableStop": "Betalingsstop verwijderen",
  "moneyOut.enum.CommandType.deletePaymentChannel": "Uitbetalingskanaal verwijderen",
  "moneyOut.enum.CommandType.editPayableStop": "Betalingsstop bewerken",
  "moneyOut.enum.CommandType.editPaymentChannel": "Uitbetalingskanaal bewerken",
  "moneyOut.enum.CommandType.removeAccessGroupAnnotation": "Verwijderen annotatie",
  "moneyOut.enum.CommandType.setDefaultPaymentChannel": "Standaarduitbetalingskanaal instellen",
  "moneyOut.enum.CompanyStatus.none": "Geen",
  "moneyOut.enum.Component.caseHandler": "",
  "moneyOut.enum.Component.legalEntity": "Rechtspersoon",
  "moneyOut.enum.Component.life": "Life",
  "moneyOut.enum.Component.moneyIn": "Incasso",
  "moneyOut.enum.Component.moneyOut": "Excasso",
  "moneyOut.enum.Component.unitlink": "UnitLink",
  "moneyOut.enum.ConfigurationEntityType.EnumDefinition": "",
  "moneyOut.enum.ConfigurationEntityType.EnumLiteral": "",
  "moneyOut.enum.ConfigurationEntityType.GlMap": "",
  "moneyOut.enum.ConfigurationEntityType.ParameterDefinition": "",
  "moneyOut.enum.ConfigurationEntityType.ParameterValue": "",
  "moneyOut.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "moneyOut.enum.ConfigurationEntityType.RegisteredTenant": "",
  "moneyOut.enum.ConfigurationEntityType.Template": "",
  "moneyOut.enum.DataSubscriptionRoleType.unspecified": "",
  "moneyOut.enum.EmploymentEndCause.deathOfEmployee": "Overlijden werknemer",
  "moneyOut.enum.EmploymentEndCause.standardEnd": "Standaard einde",
  "moneyOut.enum.ExternalPayloadProcessStatusType.deleted": "Verwijderd",
  "moneyOut.enum.ExternalPayloadProcessStatusType.processed": "Verwerkt",
  "moneyOut.enum.ExternalPayloadProcessStatusType.registered": "Geregistreerd",
  "moneyOut.enum.ExternalPayloadProcessStatusType.rejected": "Afgewezen",
  "moneyOut.enum.ExternalPayloadProcessStatusType.sent": "Verzonden",
  "moneyOut.enum.ExternalPayloadProcessStatusType.unsent": "Niet verzonden",
  "moneyOut.enum.ExternalPayloadReceiver.collcalc": "Collectieve berekeningen",
  "moneyOut.enum.ExternalPayloadReceiver.datamart2": "",
  "moneyOut.enum.ExternalPayloadReceiver.external": "Extern",
  "moneyOut.enum.ExternalPayloadReceiver.legalentity": "Rechtspersoon",
  "moneyOut.enum.ExternalPayloadReceiver.life": "Life",
  "moneyOut.enum.ExternalPayloadReceiver.moneyin": "Incasso",
  "moneyOut.enum.ExternalPayloadReceiver.moneyout": "Excasso",
  "moneyOut.enum.ExternalPayloadReceiver.unitlink": "UnitLink",
  "moneyOut.enum.ExternalPayloadType.bulkDataExport": "",
  "moneyOut.enum.ExternalPayloadType.camt53": "camt.053",
  "moneyOut.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "moneyOut.enum.ExternalPayloadType.camt54": "camt.054",
  "moneyOut.enum.ExternalPayloadType.generalLedger": "Grootboek",
  "moneyOut.enum.ExternalPayloadType.migration": "Migratie",
  "moneyOut.enum.ExternalPayloadType.namingResponse": "",
  "moneyOut.enum.ExternalPayloadType.none": "Geen",
  "moneyOut.enum.ExternalPayloadType.pain001": "pain.001",
  "moneyOut.enum.ExternalPayloadType.pain002": "pain.002",
  "moneyOut.enum.ExternalPayloadType.testTransactionalIn": "",
  "moneyOut.enum.ExternalPayloadType.testTransactionalOut": "",
  "moneyOut.enum.ExternalPayloadType.testin": "Test in",
  "moneyOut.enum.ExternalPayloadType.testout": "Test out",
  "moneyOut.enum.FPlusCompletionItemTag.deprecated": "",
  "moneyOut.enum.Gender.Female": "Vrouw",
  "moneyOut.enum.Gender.Male": "Man",
  "moneyOut.enum.Gender.Unknown": "Onbekend",
  "moneyOut.enum.GlAggregationType.correction": "Correctie",
  "moneyOut.enum.GlAggregationType.counter": "Teller",
  "moneyOut.enum.GlAggregationType.manual": "Handmatig",
  "moneyOut.enum.GlAggregationType.normal": "Normaal",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.subscribeInProgress": "Abonneren in behandeling",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.subscribed": "Geabonneerd",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.unsubscribeInProgress": "Opzeggen abonnement in behandeling",
  "moneyOut.enum.LegalEntityRegistrySubscriptionStatus.unsubscribed": "Abonnement opgezegd",
  "moneyOut.enum.LifeInsuranceEvent.accident": "Ongeluk",
  "moneyOut.enum.LifeInsuranceEvent.criticalIllness": "Kritieke ziekte",
  "moneyOut.enum.LifeInsuranceEvent.death": "Overlijden",
  "moneyOut.enum.LifeInsuranceEvent.deathOfRelated": "Overlijden gerelateerde",
  "moneyOut.enum.LifeInsuranceEvent.disability": "Arbeidsongeschiktheid",
  "moneyOut.enum.LifeInsuranceEvent.divorce": "Echtscheiding",
  "moneyOut.enum.LifeInsuranceEvent.lossOfLicense": "Verlies van licentie",
  "moneyOut.enum.LifeInsuranceEvent.paidUp": "Slaper",
  "moneyOut.enum.LifeInsuranceEvent.premiumHoliday": "Premievakantie",
  "moneyOut.enum.LifeInsuranceEvent.retirement": "Pensionering",
  "moneyOut.enum.LifeInsuranceEvent.surrender": "Afgekocht",
  "moneyOut.enum.LifeInsuranceEvent.transferOut": "Uitgaande waardeoverdracht",
  "moneyOut.enum.LifeInsuranceEvent.transferOutDivorce": "Uitgaande waardeoverdracht echtscheiding",
  "moneyOut.enum.LifeInsuranceEvent.voluntaryContinuation": "Vrijwillige voortzetting",
  "moneyOut.enum.LogLevel.all": "Alle",
  "moneyOut.enum.LogLevel.debug": "Debug",
  "moneyOut.enum.LogLevel.error": "Fouten",
  "moneyOut.enum.LogLevel.info": "Info",
  "moneyOut.enum.LogLevel.off": "Uit",
  "moneyOut.enum.LogLevel.trace": "Trace",
  "moneyOut.enum.LogLevel.warn": "Waarschuwingen",
  "moneyOut.enum.MetaAssociationOutput.aggregation": "Aggregatie",
  "moneyOut.enum.MetaAssociationOutput.composition": "Samenstelling",
  "moneyOut.enum.MetaCardinalityOutput.many": "Veel",
  "moneyOut.enum.MetaCardinalityOutput.one": "Eén",
  "moneyOut.enum.OutgoingPaymentType.lumpSum": "Eenmalige uitkering",
  "moneyOut.enum.OutgoingPaymentType.onAccount": "Voorschot",
  "moneyOut.enum.OutgoingPaymentType.paymentsRefund": "Terugbetaling",
  "moneyOut.enum.OutgoingPaymentType.recurring": "Periodiek",
  "moneyOut.enum.OutgoingPaymentType.recurringTaxFree": "Belastingvrij periodiek",
  "moneyOut.enum.OutgoingPaymentType.transit": "Doorvoer",
  "moneyOut.enum.PartnershipType.cohabitant": "Samenwonend",
  "moneyOut.enum.PartnershipType.married": "Getrouwd",
  "moneyOut.enum.PartnershipType.registeredPartnership": "Geregistreerd partnerschap",
  "moneyOut.enum.PayableStatus.approved": "Goedgekeurd",
  "moneyOut.enum.PayableStatus.cancelled": "Geannuleerd",
  "moneyOut.enum.PayableStatus.pending": "In behandeling",
  "moneyOut.enum.PayableStatus.processed": "Verwerkt",
  "moneyOut.enum.PayableStopType.lumpSum": "Eenmalige uitkering",
  "moneyOut.enum.PayableStopType.recurring": "Periodieke uitkering",
  "moneyOut.enum.PayableStopType.returnPayment": "Retourbetaling",
  "moneyOut.enum.PayableStopType.transferOut": "Uitgaande waardeoverdracht",
  "moneyOut.enum.PaymentChannelType.domestic": "Nederlandse rekening",
  "moneyOut.enum.PaymentChannelType.international": "Buitenlandse rekening",
  "moneyOut.enum.PaymentOriginType.employer": "Werkgever",
  "moneyOut.enum.PaymentOriginType.extrabilling": "Extra facturatie",
  "moneyOut.enum.PaymentOriginType.life": "Life",
  "moneyOut.enum.PaymentOriginType.transfer": "Overdrachten",
  "moneyOut.enum.PaymentOriginType.voluntary": "Vrijwillig",
  "moneyOut.enum.PaymentReceiverType.Account": "Account",
  "moneyOut.enum.PaymentReceiverType.LegalEntity": "Rechtspersoon",
  "moneyOut.enum.PaymentReceiverType.PaymentSender": "Afzender betaling",
  "moneyOut.enum.PaymentStatus.aborted": "Afgebroken",
  "moneyOut.enum.PaymentStatus.completed": "Voltooid",
  "moneyOut.enum.PaymentStatus.failed": "Mislukt",
  "moneyOut.enum.PaymentStatus.none": "Geen",
  "moneyOut.enum.PaymentStatus.ready": "Klaar",
  "moneyOut.enum.PaymentStatus.sent": "Verzonden",
  "moneyOut.enum.PaymentStopType.lumpSum": "Eenmalig",
  "moneyOut.enum.PaymentStopType.recurring": "Terugkerend",
  "moneyOut.enum.PaymentStopType.returnPayment": "Retourbetaling",
  "moneyOut.enum.PaymentStopType.transferOut": "Uitgaande waardeoverdracht",
  "moneyOut.enum.PostingTable.BP": "Balansboekingstabel",
  "moneyOut.enum.PostingTable.OPP": "Open boekingstabel",
  "moneyOut.enum.PostingType.fromPaymentRegulationLumpSum": "Vanuit betaalregeling eenmalige uitkering",
  "moneyOut.enum.PostingType.fromPaymentRegulationRecurring": "Vanuit betaalregeling periodieke uitkering",
  "moneyOut.enum.PostingType.glRounding": "Afronding grootboek",
  "moneyOut.enum.PostingType.glRoundingExcluded": "Uitgesloten grootboekafronding",
  "moneyOut.enum.PostingType.netPaymentRegulation": "Netto betaalregeling",
  "moneyOut.enum.PostingType.nonTaxableRefundPayable": "",
  "moneyOut.enum.PostingType.nonTaxableRefundPayment": "",
  "moneyOut.enum.PostingType.none": "Geen",
  "moneyOut.enum.PostingType.onAccountPayment": "Voorschotbetaling",
  "moneyOut.enum.PostingType.payable": "Betaalpost",
  "moneyOut.enum.PostingType.paymentRegulationLumpSum": "Betaalregeling eenmalige uitkering",
  "moneyOut.enum.PostingType.paymentRegulationNonTaxableRefund": "",
  "moneyOut.enum.PostingType.paymentRegulationRecurring": "Betaalregeling periodieke uitkering",
  "moneyOut.enum.PostingType.paymentRegulationTaxFree": "Belastingvrije betaalregeling",
  "moneyOut.enum.PostingType.returnedNonTaxableRefundPayment": "",
  "moneyOut.enum.PostingType.returnedNonTaxableRefundPaymentCost": "",
  "moneyOut.enum.PostingType.returnedOnAccountPayment": "Geretourneerde voorschotbetaling",
  "moneyOut.enum.PostingType.returnedOnAccountPaymentCost": "Kosten geretourneerde voorschotbetaling",
  "moneyOut.enum.PostingType.returnedTaxFreePayment": "Geretourneerde belastingvrije betaling",
  "moneyOut.enum.PostingType.returnedTaxFreePaymentCost": "Kosten geretourneerde belastingvrije betaling",
  "moneyOut.enum.PostingType.taxFreePayable": "Belastingvrije betaalpost",
  "moneyOut.enum.PostingType.taxFreePayment": "Belastingvrije betaling",
  "moneyOut.enum.PostingType.transitPayable": "Doorvoerbetaalpost",
  "moneyOut.enum.PostingType.transitPayment": "Doorvoerbetaling",
  "moneyOut.enum.ProfileType.individualProfile": "",
  "moneyOut.enum.ProfileType.lifeCycleProfile": "",
  "moneyOut.enum.RegistrySubscriptionLevel.fullRegistrySubscription": "Volledige registratie abonnement",
  "moneyOut.enum.RegistrySubscriptionLevel.none": "Geen",
  "moneyOut.enum.RegistrySubscriptionLevel.onDemand": "",
  "moneyOut.enum.RegistrySubscriptionRoleType.unspecified": "Niet gespecificeerd",
  "moneyOut.enum.ReportType.none": "Geen",
  "moneyOut.enum.ReportingEventType.cancelled": "",
  "moneyOut.enum.ReportingEventType.newReport": "",
  "moneyOut.enum.ReportingEventType.reported": "",
  "moneyOut.enum.ReportingEventType.update": "",
  "moneyOut.enum.TestBatchSpecificationType.faulty": "Defect",
  "moneyOut.enum.TestBatchSpecificationType.noop": "Noop",
  "moneyOut.enum.TestBatchSpecificationType.normal": "Normaal",
  "moneyOut.enum.VoluntaryContributionPlacement.none": "Geen",
  "moneyOut.enum.VoluntaryContributionType.oneTime": "Eenmalig",
  "moneyOut.enum.VoluntaryContributionType.recurring": "Terugkerend",
  "unitLink.enum.AccountType.correctionShadow": "Correctie schaduwrekening",
  "unitLink.enum.AccountType.cost": "Kosten",
  "unitLink.enum.AccountType.dividendShadow": "Schaduw dividend",
  "unitLink.enum.AccountType.fromLifeShadow": "Schaduw van life",
  "unitLink.enum.AccountType.fund": "Fonds",
  "unitLink.enum.AccountType.fundMergeShadow": "Schaduwrekening fondsfusie",
  "unitLink.enum.AccountType.fundReserved": "Fondsreserve",
  "unitLink.enum.AccountType.interim": "Voorloping",
  "unitLink.enum.AccountType.invested": "Geïnvesteerd",
  "unitLink.enum.AccountType.investment": "Investering",
  "unitLink.enum.AccountType.kickbackShadow": "Kickback schaduw",
  "unitLink.enum.AccountType.lifeAutoEmptyReturn": "",
  "unitLink.enum.AccountType.lifeBalanceUpdate": "Update saldo life",
  "unitLink.enum.AccountType.lifeClosedPortfolio": "Gesloten portfolio life",
  "unitLink.enum.AccountType.lifeClosedSubPortfolioReturn": "Retour gesloten sub-portfolio",
  "unitLink.enum.AccountType.lifeIn": "Life in",
  "unitLink.enum.AccountType.lifeInCounter": "",
  "unitLink.enum.AccountType.none": "Geen",
  "unitLink.enum.AccountType.reservedUnits": "Gereserveerde eenheden",
  "unitLink.enum.AccountType.rounding": "",
  "unitLink.enum.AccountType.toLifeAutoEmptyReturn": "",
  "unitLink.enum.AccountType.toLifeAutoEmptyReturnShadow": "",
  "unitLink.enum.AccountType.toLifeBalanceUpdate": "Update saldo naar life",
  "unitLink.enum.AccountType.toLifeBalanceUpdateShadow": "Update schaduw saldo naar life",
  "unitLink.enum.AccountType.toLifeClosedPortfolio": "Gesloten portfolio naar life",
  "unitLink.enum.AccountType.toLifeClosedPortfolioShadow": "Gesloten schaduw portfolio naar life",
  "unitLink.enum.AccountType.toLifeClosedSubPortfolioReturn": "Retour gesloten sub-portfolio naar Life",
  "unitLink.enum.AccountType.toLifeClosedSubPortfolioReturnShadow": "Schaduw retour gesloten sub-portfolio naar Life",
  "unitLink.enum.AccountType.trade": "Handel",
  "unitLink.enum.AccountType.tradeCycle": "Handelscyclus",
  "unitLink.enum.AccountType.tradeCycleAmount": "Bedrag handelscyclus",
  "unitLink.enum.AccountType.tradeCycleUnits": "Eenheden handelscyclus",
  "unitLink.enum.AccountType.units": "Eenheden",
  "unitLink.enum.BatchStatusType.completed": "Voltooid",
  "unitLink.enum.BatchStatusType.created": "Aangemaakt",
  "unitLink.enum.BatchStatusType.failed": "Mislukt",
  "unitLink.enum.BatchStatusType.started": "Gestart",
  "unitLink.enum.BatchStatusType.stopped": "Gestopt",
  "unitLink.enum.BulkDataType.Accounts": "",
  "unitLink.enum.BulkDataType.BalancePostings": "",
  "unitLink.enum.BulkDataType.Enums": "",
  "unitLink.enum.BulkDataType.OpenPostPostings": "",
  "unitLink.enum.BulkDataType.ParameterValueIntervals": "",
  "unitLink.enum.BulkDataType.ParameterValues": "",
  "unitLink.enum.BulkDataType.TariffTemplates": "",
  "unitLink.enum.BulkDataType.Tenants": "",
  "unitLink.enum.BulkDataType.WorkPads": "",
  "unitLink.enum.BusinessType.company": "",
  "unitLink.enum.BusinessType.person": "",
  "unitLink.enum.CommandGroupType.advance": "Doorgaan",
  "unitLink.enum.CommandGroupType.annotation": "Annotatie",
  "unitLink.enum.CommandGroupType.calculation": "Berekening",
  "unitLink.enum.CommandGroupType.employerAgreement": "Werkgeversovereenkomst",
  "unitLink.enum.CommandGroupType.employment": "Dienstverband",
  "unitLink.enum.CommandGroupType.legalEntity": "Rechtspersoon",
  "unitLink.enum.CommandGroupType.moneyIn": "Incasso",
  "unitLink.enum.CommandGroupType.moneyOut": "Excasso",
  "unitLink.enum.CommandGroupType.none": "Geen",
  "unitLink.enum.CommandGroupType.policyChange": "Wijzig polis",
  "unitLink.enum.CommandGroupType.posting": "Boekingen",
  "unitLink.enum.CommandGroupType.tax": "Belasting",
  "unitLink.enum.CommandGroupType.unitlink": "UnitLink",
  "unitLink.enum.CommandType.addAccessGroupAnnotation": "Toevoegen annotatie",
  "unitLink.enum.CommandType.addFundDividend": "Toevoegen fondsdividend",
  "unitLink.enum.CommandType.addFundMerge": "Toevoegen fondsfusie",
  "unitLink.enum.CommandType.addPortfolioBalancePostings": "Toevoegen portfolio balansboekingen",
  "unitLink.enum.CommandType.amendAccessGroupAnnotation": "Wijzigen annotatie",
  "unitLink.enum.CommandType.autoEmptyMove": "Automatische leegloopverplaatsing",
  "unitLink.enum.CommandType.changeFund": "Wijzig fonds",
  "unitLink.enum.CommandType.closeSubPortfolio": "Gesloten sub-portfolio",
  "unitLink.enum.CommandType.defaultTemplate": "Standaard sjabloon",
  "unitLink.enum.CommandType.editPortfolio": "Bewerken portfolio",
  "unitLink.enum.CommandType.endEmployment": "Beëindigen dienstverband",
  "unitLink.enum.CommandType.investmentSpec": "Specificatie investering",
  "unitLink.enum.CommandType.investmentTrade": "Handel investering",
  "unitLink.enum.CommandType.moveSubPortfolio": "Verplaatsen sub-portfolio",
  "unitLink.enum.CommandType.newFund": "Nieuw fonds",
  "unitLink.enum.CommandType.newSubPortfolios": "Nieuwe sub-portfolio",
  "unitLink.enum.CommandType.portfolioCorrection": "Correctie portfolio",
  "unitLink.enum.CommandType.rebalance": "Rebalance",
  "unitLink.enum.CommandType.removeAccessGroupAnnotation": "Verwijderen annotatie",
  "unitLink.enum.CommandType.revertCloseSubPortfolio": "Terugdraaien gelosten sub-portfolio",
  "unitLink.enum.CommandType.revertEndEmployment": "Einde dienstverband terugdraaien",
  "unitLink.enum.CommandType.revertMoveSubPortfolio": "Terugdraaien verplaatsen sub-portfolio",
  "unitLink.enum.CommandType.revertNewSubPortfolios": "Terugdraaien nieuwe sub-portfolio",
  "unitLink.enum.CommandType.revertStartEmployment": "Start dienstverband terugdraaien",
  "unitLink.enum.CommandType.setPortfolioOwner": "Zet portfolio eigenaar",
  "unitLink.enum.CommandType.startEmployment": "Starten dienstverband",
  "unitLink.enum.CommandType.switchSubPortfolioCommand": "Opdracht sub-portfolio wisselen",
  "unitLink.enum.CommandType.switchSubPortfolioGroupCommand": "Opdracht groep sub-portfolios wisselen",
  "unitLink.enum.CommandType.switchTrade": "Wissel handel",
  "unitLink.enum.CommandType.tradeExecution": "Uitvoeren handel",
  "unitLink.enum.CommandType.unitlinkConversion": "Conversie UnitLink",
  "unitLink.enum.ConfigurationEntityType.EnumDefinition": "",
  "unitLink.enum.ConfigurationEntityType.EnumLiteral": "",
  "unitLink.enum.ConfigurationEntityType.GlMap": "",
  "unitLink.enum.ConfigurationEntityType.ParameterDefinition": "",
  "unitLink.enum.ConfigurationEntityType.ParameterValue": "",
  "unitLink.enum.ConfigurationEntityType.ReconciliationSpec": "",
  "unitLink.enum.ConfigurationEntityType.RegisteredTenant": "",
  "unitLink.enum.ConfigurationEntityType.Template": "",
  "unitLink.enum.DataSubscriptionRoleType.unspecified": "",
  "unitLink.enum.EditType.update": "",
  "unitLink.enum.EventStopKind.applyStop": "",
  "unitLink.enum.EventStopKind.communicationStop": "",
  "unitLink.enum.EventStopKind.errorApplyStop": "",
  "unitLink.enum.EventStopKind.fullStop": "",
  "unitLink.enum.ExternalPayloadProcessStatusType.deleted": "Verwijderd",
  "unitLink.enum.ExternalPayloadProcessStatusType.processed": "Verwerkt",
  "unitLink.enum.ExternalPayloadProcessStatusType.registered": "Geregistreerd",
  "unitLink.enum.ExternalPayloadProcessStatusType.rejected": "Afgewezen",
  "unitLink.enum.ExternalPayloadProcessStatusType.sent": "Verzonden",
  "unitLink.enum.ExternalPayloadProcessStatusType.unsent": "Niet verzonden",
  "unitLink.enum.ExternalPayloadReceiver.collcalc": "Collectieve berekeningen",
  "unitLink.enum.ExternalPayloadReceiver.datamart2": "",
  "unitLink.enum.ExternalPayloadReceiver.external": "Extern",
  "unitLink.enum.ExternalPayloadReceiver.legalentity": "Rechtspersoon",
  "unitLink.enum.ExternalPayloadReceiver.life": "Life",
  "unitLink.enum.ExternalPayloadReceiver.moneyin": "Incasso",
  "unitLink.enum.ExternalPayloadReceiver.moneyout": "Excasso",
  "unitLink.enum.ExternalPayloadReceiver.unitlink": "UnitLink",
  "unitLink.enum.ExternalPayloadType.acknowledgements": "Bevestigingen",
  "unitLink.enum.ExternalPayloadType.bulkDataExport": "",
  "unitLink.enum.ExternalPayloadType.camt53": "camt.053",
  "unitLink.enum.ExternalPayloadType.camt53Returns": "camt.053 retour",
  "unitLink.enum.ExternalPayloadType.camt54": "camt.054",
  "unitLink.enum.ExternalPayloadType.fundPrices": "Fondskoersen",
  "unitLink.enum.ExternalPayloadType.generalLedger": "Grootboek",
  "unitLink.enum.ExternalPayloadType.migration": "Migratie",
  "unitLink.enum.ExternalPayloadType.namingResponse": "",
  "unitLink.enum.ExternalPayloadType.none": "Geen",
  "unitLink.enum.ExternalPayloadType.orderConfirmation": "Orderbevestiging",
  "unitLink.enum.ExternalPayloadType.pain001": "pain.001",
  "unitLink.enum.ExternalPayloadType.pain002": "pain.002",
  "unitLink.enum.ExternalPayloadType.testTransactionalIn": "",
  "unitLink.enum.ExternalPayloadType.testTransactionalOut": "",
  "unitLink.enum.ExternalPayloadType.testin": "Test in",
  "unitLink.enum.ExternalPayloadType.testout": "Test uit",
  "unitLink.enum.ExternalPayloadType.tradeOrder": "Handelsorder",
  "unitLink.enum.ExternalPayloadType.unitlinkConversion": "Conversie UnitLink",
  "unitLink.enum.FPlusCompletionItemTag.deprecated": "",
  "unitLink.enum.FundRiskLevel.none": "Geen",
  "unitLink.enum.Gender.Female": "",
  "unitLink.enum.Gender.Male": "",
  "unitLink.enum.Gender.Unknown": "",
  "unitLink.enum.GlAggregationType.correction": "Correctie",
  "unitLink.enum.GlAggregationType.counter": "Teller",
  "unitLink.enum.GlAggregationType.manual": "Handmatig",
  "unitLink.enum.GlAggregationType.normal": "Normaal",
  "unitLink.enum.InvestmentAllocation.active": "Aktief",
  "unitLink.enum.InvestmentAllocation.profile": "Profiel",
  "unitLink.enum.LogLevel.all": "Alle",
  "unitLink.enum.LogLevel.debug": "Debug",
  "unitLink.enum.LogLevel.error": "Fouten",
  "unitLink.enum.LogLevel.info": "Info",
  "unitLink.enum.LogLevel.off": "Uit",
  "unitLink.enum.LogLevel.trace": "Trace",
  "unitLink.enum.LogLevel.warn": "Waarschuwingen",
  "unitLink.enum.MetaAssociationOutput.aggregation": "Aggregatie",
  "unitLink.enum.MetaAssociationOutput.composition": "Samenstelling",
  "unitLink.enum.MetaCardinalityOutput.many": "Veel",
  "unitLink.enum.MetaCardinalityOutput.one": "Eén",
  "unitLink.enum.PortfolioStatementPeriod.days": "",
  "unitLink.enum.PortfolioStatementPeriod.months": "",
  "unitLink.enum.PortfolioStatementPeriod.years": "",
  "unitLink.enum.PostingTable.BP": "Balansboekingstabel",
  "unitLink.enum.PostingTable.OPP": "Open boekingstabel",
  "unitLink.enum.PostingType.autoEmptyMove": "Automatische leegloopverplaatsing",
  "unitLink.enum.PostingType.autoEmptyMoveFromLife": "Automatische leegloopverplaatsing van Life",
  "unitLink.enum.PostingType.autoEmptyReturn": "Automatische leegloopretour",
  "unitLink.enum.PostingType.balance": "Saldo",
  "unitLink.enum.PostingType.balanceUpdateFromLife": "Balansupdate vanuit Life",
  "unitLink.enum.PostingType.closeSubPortfolio": "Sluit sub-portfolio",
  "unitLink.enum.PostingType.closedSubPortfolioReturn": "Retour gesloten sub-portfolio",
  "unitLink.enum.PostingType.deInvested": "Deinvesteren",
  "unitLink.enum.PostingType.deltaMoveSubPortfolio": "Verplaats verschil sub-portfolio",
  "unitLink.enum.PostingType.dividend": "Dividend",
  "unitLink.enum.PostingType.endEmploymentFromLife": "Einde dienstverband vanuit Life",
  "unitLink.enum.PostingType.fundCost": "Fondskosten",
  "unitLink.enum.PostingType.fundMerge": "Fondsfusie",
  "unitLink.enum.PostingType.glRounding": "Afronding grootboek",
  "unitLink.enum.PostingType.glRoundingExcluded": "Uitgesloten grootboekafronding",
  "unitLink.enum.PostingType.invested": "Geïnvesteerd",
  "unitLink.enum.PostingType.investedDiff": "Verschil geïnvesteerd",
  "unitLink.enum.PostingType.investedInternal": "Interne belegging",
  "unitLink.enum.PostingType.investmentFromLife": "Investering van life",
  "unitLink.enum.PostingType.kickback": "Kickback",
  "unitLink.enum.PostingType.moveSubPortfolio": "Verplaats sub-portfolio",
  "unitLink.enum.PostingType.moveSubPortfolioFromLife": "Verplaats sub-portfolio van life",
  "unitLink.enum.PostingType.newSubPortfolio": "Nieuwe sub-portfolio",
  "unitLink.enum.PostingType.newSubPortfolioFromLife": "Nieuwe sub-portfolio van life",
  "unitLink.enum.PostingType.none": "Geen",
  "unitLink.enum.PostingType.revertBalanceUpdateFromLife": "Balansupdate vanuit Life terugdraaien",
  "unitLink.enum.PostingType.revertCloseSubPortfolio": "Terugdraaien gesloten sub-portfolio",
  "unitLink.enum.PostingType.revertEndEmploymentFromLife": "Einde dienstverband vanuit Life terugdraaien",
  "unitLink.enum.PostingType.revertMoveSubPortfolioFromLife": "Terugdraaien verplaatsing sub-portfolio van life",
  "unitLink.enum.PostingType.revertNewSubPortfolioFromLife": "Terugdraaien nieuwe sub-portfolio van life",
  "unitLink.enum.PostingType.revertStartEmploymentFromLife": "Start dienstverband vanuit Life terugdraaien",
  "unitLink.enum.PostingType.startEmploymentFromLife": "Start dienstverband vanuit Life",
  "unitLink.enum.PostingType.subPortfolioMove": "Verplaatsen sub-portfolio",
  "unitLink.enum.PostingType.tradeAmount": "Handelsbedrag",
  "unitLink.enum.PostingType.tradeAmountCorrection": "Correctie handelsbedrag",
  "unitLink.enum.PostingType.tradeAmountDividend": "Dividend handelsbedrag",
  "unitLink.enum.PostingType.tradeAmountFundCost": "Handelsbedrag fondskosten",
  "unitLink.enum.PostingType.tradeCost": "Handelskosten",
  "unitLink.enum.PostingType.tradeUnit": "Handelseenheid",
  "unitLink.enum.PostingType.tradeUnitCorrection": "Correctie handelseenheden",
  "unitLink.enum.PostingType.yield": "Rendement",
  "unitLink.enum.ProfileType.individualProfile": "Individueel profiel",
  "unitLink.enum.ProfileType.lifeCycleProfile": "Lifecycle profiel",
  "unitLink.enum.PrognosisAssetClass.None": "Geen",
  "unitLink.enum.ReportType.none": "Geen",
  "unitLink.enum.ReportingEventType.cancelled": "",
  "unitLink.enum.ReportingEventType.newReport": "",
  "unitLink.enum.ReportingEventType.reported": "",
  "unitLink.enum.ReportingEventType.update": "",
  "unitLink.enum.SwitchCommandType.paymentAndSavingsDistribution": "Betalings- en spaarverdeling",
  "unitLink.enum.SwitchCommandType.paymentDistribution": "Betalingsverdeling",
  "unitLink.enum.SwitchCommandType.savingsDistribution": "Spaarverdeling",
  "unitLink.enum.TestBatchSpecificationType.faulty": "Defect",
  "unitLink.enum.TestBatchSpecificationType.noop": "Noop",
  "unitLink.enum.TestBatchSpecificationType.normal": "Normaal",
  "unitLink.enum.TradeCycleStatusType.aggregated": "Geaggregeerd",
  "unitLink.enum.TradeCycleStatusType.closed": "Gesloten",
  "unitLink.enum.TradeCycleStatusType.completed": "Voltooid",
  "unitLink.enum.TradeCycleStatusType.completelyAcknowledged": "Volledig erkend",
  "unitLink.enum.TradeCycleStatusType.completelySent": "Volledig verzonden",
  "unitLink.enum.TradeCycleStatusType.invested": "Geïnvesteerd",
  "unitLink.enum.TradeCycleStatusType.partlyAcknowledged": "Gedeeltelijk erkend",
  "unitLink.enum.TradeCycleStatusType.partlySent": "Gedeeltelijk verzonden",
  "unitLink.enum.TradeCycleStatusType.somePricesReceived": "Een aantal koersen ontvangen",
  "unitLink.enum.TradeCycleStatusType.started": "Gestart",
  "unitLink.enum.TradeCycleType.none": "Geen",
})

export const nlConfiguredEnums = defineTranslations<TranslationRecord<typeof enConfiguredEnums>>()({
  "moneyIn.enum.InvoiceBundlingPenaltyType.lateDeliveryPenalty": "Late levering",
  "moneyIn.enum.PaymentType.PLACEHOLDER": "",
})
